const de: Record<string, string> = {
  // nav
  'nav.overview': 'Übersicht',
  'nav.members': 'Mitglieder',
  'nav.debates': 'Debatten',
  'nav.bills': 'Geschäfte',
  'nav.votes': 'Abstimmungen',
  'nav.parties': 'Parteien',
  'nav.sessions': 'Sessionen',
  'nav.committees': 'Kommissionen',
  'nav.chatHistory': 'Chat-Verlauf',
  'nav.reports': 'Berichte',
  'nav.usage':       'Nutzung',
  'nav.feedback':    'Feedback',
  'nav.documentation': 'Doku',
  'settings.api.title':       'API-Status',
  'settings.api.health':      'Backend-Gesundheit',
  'settings.api.desc':        'Alle 60 Sekunden abgefragt. Kombiniert Postgres- und Meilisearch-Erreichbarkeit.',
  'settings.api.ok':          'Alle Systeme betriebsbereit',
  'settings.api.degraded':    'Teilweise eingeschränkt',
  'settings.api.unreachable': 'Nicht erreichbar',
  // Admin-Feedback-Triage (/feedback)
  'feedback.title':              'Feedback-Triage',
  'feedback.subtitle':           'Negative Chat-Antworten mit der zugehörigen Nutzerfrage.',
  'feedback.window':             'Zeitraum',
  'feedback.errorLoad':          'Feedback konnte nicht geladen werden',
  'feedback.kpiDownvotes':       'Negative Bewertungen',
  'feedback.noPrior':            'keine Vergleichsdaten',
  'feedback.vsPrior':            'ggü. Vorperiode',
  'feedback.kpiRatio':           'Negativ-Quote',
  'feedback.rated':              'bewertet',
  'feedback.kpiWithComment':     'Mit Kommentar',
  'feedback.commentSub':         'mit Freitext-Detail',
  'feedback.kpiTopCategory':     'Top-Kategorie',
  'feedback.topCategorySub':     'häufigstes Problem',
  'feedback.categoryHistogram':  'Nach Kategorie',
  'feedback.clearCategory':      'Filter löschen',
  'feedback.chartHint':          'Balken anklicken, um die Liste zu filtern.',
  'feedback.empty':              'Keine negativen Bewertungen in diesem Zeitraum.',
  'feedback.hasComment':         'Kommentar',
  'feedback.openConversation':   'Konversation öffnen',
  'feedback.userLabel':          'Nutzer',
  'feedback.assistantLabel':     'Assistent',
  'feedback.noUserQuery':        '(keine vorangehende Nutzerfrage)',
  'feedback.noAssistantText':    '(keine Textantwort — nur Tool-Aufrufe)',
  'feedback.withComment':        'Mit Kommentar',
  'feedback.filterCommentOn':    'Nur Einträge mit Freitext-Kommentar anzeigen',
  'feedback.filterCommentOff':   'Zeigt Einträge mit Kommentar — klicken zum Aufheben',
  'feedback.conversation':       'Konversation',
  'feedback.openInChatHistory':  'In Chat-Verlauf öffnen',
  'feedback.turns':              'Frage-Antwort-Runden',
  'common.previous':             'Zurück',
  'common.next':                 'Weiter',
  'common.close':                'Schliessen',
  'nav.settings': 'Einstellungen',
  // Feedback affordances (👍 / 👎 / Kopieren + Kategorisierungsdialog)
  'chat.feedback.helpful':            'Als hilfreich markieren',
  'chat.feedback.reportProblem':      'Problem melden',
  'chat.feedback.copy':               'Antwort kopieren',
  'chat.feedback.copied':             'Kopiert',
  'chat.feedback.modal.title':        'Was war das Problem?',
  'chat.feedback.modal.hint':         'Kategorisieren Sie das Problem (optional) und ergänzen Sie Details. Beides ist optional — auch ein blosses 👎 ist ein nützliches Signal.',
  'chat.feedback.modal.category':     'Kategorie',
  'chat.feedback.modal.comment':      'Kommentar (optional)',
  'chat.feedback.modal.commentPlaceholder': 'Was war falsch, was hatten Sie erwartet?',
  'chat.feedback.modal.cancel':       'Abbrechen',
  'chat.feedback.modal.submit':       'Absenden',
  'chat.feedback.cat.inaccurate':                 'Ungenau',
  'chat.feedback.cat.inaccurate.desc':            'Falsche Tatsache oder erfundene Daten',
  'chat.feedback.cat.incomplete':                 'Unvollständig',
  'chat.feedback.cat.incomplete.desc':            'Nur ein Teil der Frage beantwortet',
  'chat.feedback.cat.wrong_citation':             'Falsche Quelle',
  'chat.feedback.cat.wrong_citation.desc':        'Quellenlink kaputt oder zeigt auf die falsche Entität',
  'chat.feedback.cat.off_topic':                  'Thema verfehlt',
  'chat.feedback.cat.off_topic.desc':             'Hat die gestellte Frage nicht beantwortet',
  'chat.feedback.cat.formatting':                 'Formatierung / Sprache',
  'chat.feedback.cat.formatting.desc':            'Falsche Sprache, kaputte Tabelle, usw.',
  'chat.feedback.cat.other':                      'Sonstiges',
  'chat.feedback.cat.other.desc':                 'Bitte erläutern Sie im Kommentar',
  'chat.history.pinned':              'Angeheftet',
  'chat.history.today':               'Heute',
  'chat.history.yesterday':           'Gestern',
  'chat.history.thisWeek':            'Diese Woche',
  'chat.history.older':               'Älter',
  'chat.fromChat':                    'aus dem Chat',
  'common.search':                    'Suche',
  'chat.history.newChat':             'Neuer Chat',
  'chat.history.searchPlaceholder':   'Sitzungen suchen…',
  'chat.history.empty':               'Noch keine gespeicherten Unterhaltungen. Starten Sie eine im Chat-Widget.',
  'chat.history.untitled':            'Unbenannter Chat',
  'chat.history.pin':                 'Anheften',
  'chat.history.unpin':               'Lösen',
  'chat.history.rename':              'Umbenennen',
  'chat.history.archive':             'Archivieren',
  'chat.history.selectHint':          'Wählen Sie eine Unterhaltung aus der Liste, um sie zu lesen. Neue Chats starten Sie im Chat-Widget unten rechts.',
  'chat.history.continue':            'Im Chat fortsetzen',
  'reports.listTitle':             'Berichte',
  'reports.empty':                 'Noch keine Berichte. Wählen Sie Konversationen im Chat-Verlauf aus und erstellen Sie einen.',
  'reports.untitled':              'Unbenannter Bericht',
  'reports.selectHint':            'Wählen Sie einen Bericht zum Lesen aus oder erstellen Sie einen neuen aus Ihren Konversationen im Chat-Verlauf.',
  'reports.generatedOn':           'Erstellt am',
  'reports.sourcesNote':           'Die Quellen verweisen auf die offizielle Website des Schweizer Parlaments (parlament.ch). Mit KI aus gespeicherten Konversationen erstellt – bitte anhand der zitierten Quellen überprüfen.',
  'reports.modelTip':              'Modell automatisch anhand der Berichtsgrösse gewählt',
  'reports.downloadPdf':           'PDF',
  'reports.downloadMd':            'Markdown',
  'reports.popupBlocked':          'Bitte erlauben Sie Pop-ups für diese Seite, um das PDF herunterzuladen.',
  'reports.status.failed':         'fehlgeschlagen',
  'reports.confirmDelete':         'Diesen Bericht löschen? Dies kann nicht rückgängig gemacht werden.',
  'reports.generateTitle':         'Bericht erstellen',
  'reports.generateHint':          'Aus der ausgewählten Konversation wird ein professioneller Recherchebericht erstellt, nach Themen gegliedert. Er zitiert ausschliesslich offizielle parlament.ch-Quellen.',
  'reports.turnsSelected':         'Ausgewählte Beiträge',
  'reports.conversationsSelected': 'Ausgewählte Konversationen',
  'reports.language':              'Berichtssprache',
  'reports.lang.de':               'Deutsch',
  'reports.lang.fr':               'Französisch',
  'reports.lang.it':               'Italienisch',
  'reports.lang.en':               'Englisch',
  'reports.generate':              'Bericht erstellen',
  'reports.generating':            'Wird erstellt…',
  'reports.generateError':         'Der Bericht konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
  'reports.selectSessions':        'Für Bericht auswählen',
  'reports.selectTurns':           'Für Bericht auswählen',
  'reports.selectDone':            'Auswahl beenden',
  'reports.generateN':             'Bericht erstellen ({n})',
  'reports.turnsChosen':           '{n} Beitrag/Beiträge ausgewählt',
  'common.cancel':                 'Abbrechen',
  'common.delete':                 'Löschen',
  'debates.tab.search':                 'Suche',
  'debates.tab.trends':                 'Trends',
  // Trends — compare-factions toggle
  'debates.trends.compareLabel':     '+ vergleichen',
  'debates.trends.exitCompare':      '× Vergleich',
  'debates.trends.compareTooltip':   'Mehrere Fraktionen nebeneinander vergleichen',
  'common.errorLoad':                            'Laden fehlgeschlagen',
  'debates.trends.title':               'Rhetorische Trends',
  'debates.trends.subtitle':            'Jährliche Verschiebungen in der Sprache der Parlamentarier — Stimmung, Haltung, Föderalismus und emotionale Intensität.',
  'debates.trends.empty':               'Keine Reden für die aktuellen Filter.',
  'debates.trends.allFactions':         'Fraktionen',
  'debates.trends.allParties':          'Parteien',
  'debates.trends.allSessions':         'Sessionen',
  'debates.trends.councillorPlaceholder': 'Ratsmitglied-Name…',
  'debates.trends.chunksHint':            'KI-bewertete Abschnitte dieser Reden (lange Reden werden für die Analyse aufgeteilt)',
  'faction.cohesion':                'Geschlossenheit',
  'faction.rebels':                  'Abweichler',
  'faction.cohesionByYear':          'Nach Jahr',
  'faction.cohesionByTopic':         'Nach Thema',
  'faction.cohesionYearSubtitle':    'Geschlossenheit pro Jahr — Anteil der abgegebenen Stimmen, die mit der Fraktionsmehrheit gingen.',
  'faction.cohesionTopicSubtitle':   'Geschlossenheit pro Politikbereich — die niedrigsten Werte zeigen die intern strittigsten Themen.',
  'faction.cohesionSrNote':          'Namentliche Abstimmungsdaten des Ständerats gibt es erst ab 2022.',
  'faction.rebelsSubtitle':          'Mitglieder nach Häufigkeit der Abweichung von der Fraktionsmehrheit (Ja/Nein-Stimmen). Patt-Abstimmungen ausgeschlossen; min. 20 abgegebene Ja/Nein-Stimmen.',
  'faction.allChambers':             'Beide Räte',
  'faction.rebellionRate':           'Abweichungsrate',
  'faction.rebellionRateTip':        'Abweichungen ÷ Ja/Nein-Stimmen — Anteil der Ja/Nein-Stimmen, bei denen das Mitglied von der Fraktionslinie abgewichen ist.',
  'faction.rebellionDiverges':       'Abweichungen',
  'faction.rebellionDivergesTip':    'Anzahl der Ja/Nein-Stimmen, bei denen das Mitglied gegen die Fraktionsmehrheit gestimmt hat.',
  'faction.rebellionVotes':          'Ja/Nein',
  'faction.rebellionVotesTip':       'Ja/Nein-Stimmen, die das Mitglied persönlich abgegeben hat und die in dieses Ranking einfliessen. Enthaltungen sowie Patt-Abstimmungen werden ausgeschlossen — daher die Differenz zum Wert „Im Register" auf der Mitgliederseite.',
  'faction.votes':                   'Abstimmungen',
  'parties.unityRanking':            'Fraktionsgeschlossenheit-Ranking',
  'parties.unityRankingTip':         'Fraktionsgeschlossenheit pro Kammer (National- und Ständerat). Ständerats-Daten ab 2022. Auf eine Leiste klicken, um die Fraktion zu öffnen.',
  'votes.demographics.title':        'Statistik',
  'votes.demographics.subtitle':     'wie sich diese Abstimmung im Rat verteilte',
  'votes.demographics.notParticipating': 'Nicht teilgenommen',
  'votes.demographics.total':        'Gesamt',
  'votes.demographics.tenure':       'Amtszeit',
  'tenure.bucket.veteran':           'Bisherige',
  'tenure.bucket.newcomer':          'Neugewählte',
  'member.member':                   'Mitglied',
  'bills.tab.search':                'Suche',
  'bills.tab.analytics':             'Analyse',
  'bills.analytics.title':           'Geschäfte-Analyse',
  'bills.analytics.subtitle':        'Wie sich Einreichungen nach Thema, Jahr, Typ, Departement oder Intention verteilen.',
  'bills.analytics.clickToFilter':   'Zum Filtern klicken',
  'bills.analytics.yearRange':       'Jahre',
  'bills.analytics.yearFrom':        'Von Jahr',
  'bills.analytics.yearTo':          'Bis Jahr',
  'bills.analytics.allYears':        'Alle',
  'common.clear':                    'Zurücksetzen',
  'bills.analytics.submissions':     'Einreichungen',
  'bills.analytics.concluded':       'Erledigt',
  'bills.analytics.metricsTooltip':  'Einreichungen zählt die pro Gruppe im gewählten Zeitraum eingereichten Geschäfte. Erledigt gibt an, wie viele davon inzwischen erledigt sind (Status „Erledigt“), mit dem Anteil in Klammern.',
  'bills.analytics.topic':           'Thema',
  'bills.analytics.year':            'Jahr',
  'bills.analytics.affairType':      'Typ',
  'bills.analytics.department':      'Departement',
  'bills.analytics.intent':          'Intention',
  'bills.analytics.faction':         'Fraktion',
  'bills.analytics.party':           'Partei',
  'bills.analytics.canton':          'Kanton',
  'bills.analytics.council':         'Rat',
  'bills.analytics.councillor':      'Ratsmitglied',
  'bills.analytics.committee':       'Kommission',
  'bills.analytics.hiddenDimTip':    'Über den Chatbot angewendet. Auf eine sichtbare Dimension wechseln zum Verlassen.',
  'bills.legislativePeriod':         'Legislatur',
  'bills.allLegPeriods':             'Legislaturen',
  'bills.dateRange':                 'Datum',
  'bills.fcRecommendation':          'BR-Empfehlung',
  'bills.committeeRecommendation':   'Kommissions-Empfehlung',
  'filter.tooltip.legislativePeriod': 'Nach Legislaturperiode filtern (52=2023→, 51=2019–23, 50=2015–19)',
  'parties.composition.title':       'Ratszusammensetzung',
  'debates.trends.scoreAxis':           'Wert',
  'debates.trends.emotionalityAvg':     'Ø Emotionalität',
  'debates.trends.metric.sentiment':    'Stimmung',
  'debates.trends.metric.alignment':    'Haltung',
  'debates.trends.metric.federalism':   'Föderalismus',
  'debates.trends.metric.emotionality': 'Emotionalität',
  // anchor
  'anchor.researching': 'Recherche:',
  'anchor.clear': 'Löschen',
  // common
  'common.all': 'Alle',
  'common.impact': 'Einfluss',
  'common.sensitivity': 'Polarisierung',
  'common.centralization': 'Föderalismus',
  'common.centralizShort': 'Föderalismus',
  'common.impact.tooltip': 'Wie stark diese Vorlage die Schweizer Gesellschaft, Wirtschaft oder Gesetzgebung betrifft. 1 = gering/begrenzt, 10 = weitreichend/bedeutend.',
  'common.sensitivity.tooltip': 'Wie politisch umstritten oder spaltend dieses Thema ist. 1 = unumstritten, 10 = stark polarisierend.',
  'common.centralization.tooltip': 'Richtung der Machtverschiebung. 1 = stark kantonal/lokal, 10 = stark bundesstaatlich/zentralisiert.',

  // Phase 4.5 — KI-klassifizierte Anomalie-Badges
  'anomaly.controversial':            'Umstritten',
  'anomaly.controversial.tooltip':    'Bewertung der polarisierenden Tendenz des Geschäfts auf die Schweizer Gesellschaft (Wirtschaft, Politik, Recht und Kultur). 1 = geringe Polarisierung / 10 = ausgeprägte Polarisierung',
  'anomaly.polarizing':               'Polarisierend',
  'anomaly.polarizing.tooltip':       'Bewertung der polarisierenden Tendenz des Geschäfts auf die Schweizer Gesellschaft (Wirtschaft, Politik, Recht und Kultur). 1 = geringe Polarisierung / 10 = ausgeprägte Polarisierung',
  'anomaly.highImpact':               'Einfluss',
  'anomaly.highImpact.tooltip':       'Bewertung der Auswirkungen des Geschäfts auf die Schweizer Gesellschaft (Wirtschaft, Politik, Recht und Kultur). 1 = begrenzter Einfluss / 10 = weitreichender Einfluss',
  'anomaly.centralizing':             'Zentralisierend',
  'anomaly.centralizing.tooltip':     'Bewertung eines Geschäfts betreffend einer Vereinheitlichung und Zentralisierung der Schweizer Gesellschaft (Wirtschaft, Politik, Recht und Kultur). 1 = Stärkung des Föderalismus / 10 = Ausbau des Zentralismus',
  'anomaly.decentralizing':           'Föderalistisch',
  'anomaly.decentralizing.tooltip':   'Bewertung eines Geschäfts betreffend einer Vereinheitlichung und Zentralisierung der Schweizer Gesellschaft (Wirtschaft, Politik, Recht und Kultur). 1 = Stärkung des Föderalismus / 10 = Ausbau des Zentralismus',
  'anomaly.minorityReport':           'Minderheitsantrag',
  'anomaly.minorityReport.tooltip':   'Eine Kommissionsminderheit hat einen schriftlichen Gegenantrag (bekämpft) eingereicht — die Vorlage trägt einen Gegenvorschlag jenseits der Mehrheitsposition.',
  'anomaly.fastTracked':              'Beschleunigt',
  'anomaly.fastTracked.tooltip':      'Aussergewöhnlich rasch erledigt — unter 90 Tagen von der Einreichung bis zur Schlussabstimmung. Häufig ein Hinweis auf Dringlichkeitsverfahren.',
  'anomaly.heated':                   'Hitzig',
  'anomaly.heated.tooltip':           'Emotional aufgeladene Rede — Emotionalitätsbewertung 7–8 von 10.',
  'anomaly.confrontational':          'Konfrontativ',
  'anomaly.confrontational.tooltip':  'Stark konfrontativer Ton — Emotionalitätsbewertung 9 oder 10 von 10.',
  'anomaly.closeVote':                'Knappe Abstimmung',
  'anomaly.closeVote.tooltip':        'Mit weniger als 5% Differenz zwischen Ja und Nein entschieden — wenige Stimmen hätten das Ergebnis gekippt.',
  'anomaly.rapporteur':               'Berichterstatter',
  'anomaly.rapporteur.tooltip':       'Offizielle Kommissionssprecherin bzw. -sprecher — die Rede vertritt die formelle Position der Kommission im Plenum.',
  'common.submittedBy': 'Eingereicht von',
  'common.department': 'Departement',
  'common.status': 'Status',
  'common.trigger': 'Auslöser',
  'common.words': 'Wörter',
  'common.back': 'Zurück',
  'common.active': 'Aktiv',
  'common.loading': 'Lädt…',
  'common.loadMore': 'Mehr laden',
  'common.clearAll': 'Alle löschen',
  'common.retry': 'Erneut versuchen',
  'common.error.title': 'Etwas ist schiefgelaufen',
  'common.error.body': 'Dieser Inhalt konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
  'council.NR': 'Nationalrat',
  'council.SR': 'Ständerat',
  'council.V': 'Vereinigte Bundesversammlung',
  'council.BR': 'Bundesrat',
  'filter.tooltip.party':     'Nach Parteizugehörigkeit filtern. Mehrere Parteien gleichzeitig wählbar.',
  'filter.tooltip.faction':   'Nach Fraktion filtern (V·SVP, S·SP, RL·FDP, M-E·Mitte, G·Grüne, GL·GLP).',
  'filter.tooltip.canton':    'Nach Kanton filtern. Für kantonsübergreifende Vergleiche mehrere wählen.',
  'filter.tooltip.council':   'Nationalrat vs Ständerat. Beide wählen für alle Ratsmitglieder.',
  'filter.tooltip.gender':    'Mitglieder nach Geschlecht filtern.',
  'filter.tooltip.committee': 'Nach aktueller Kommissionsmitgliedschaft filtern. Mehrere für Schnittmengen wählen.',
  'filter.year':              'Jahr',
  'filter.session':           'Session',
  'filter.tooltip.year':      'Einreichungsjahr des Geschäfts — wann es erstmals eingereicht wurde. Nicht das Jahr der letzten Behandlung oder Abstimmung.',
  'filter.tooltip.session':   'Sessionstyp innerhalb des Jahres (Frühling, Sommer, Herbst, Winter).',
  'filter.tooltip.status':    'Aktiv = derzeit amtierende Mitglieder. Ehemalig = nur frühere Mitglieder.',
  // Bills page (4.8 + IWP Bundle 1)
  'filter.tooltip.billType':            'Art des parlamentarischen Vorstosses: Motion, Postulat, Interpellation, Parlamentarische Initiative usw. Mehrere Typen kombinierbar.',
  'filter.tooltip.billStatus':          'Aktueller Verfahrensstand des Geschäfts (z.B. eingereicht, in Bearbeitung, angenommen, abgelehnt, zurückgezogen).',
  'filter.tooltip.department':          'Zuständiges Bundesamt oder Departement.',
  'filter.tooltip.number':              'Nach exakter Geschäftsnummer filtern, z.B. 24.3145. Platzhalter werden nicht unterstützt.',
  'filter.tooltip.submittedBy':         'Nach Einreichendem filtern — Ratsmitglied, Fraktion oder Institution wie Bundesrat oder eine parlamentarische Kommission.',
  'filter.tooltip.aiTopic':             'KI-klassifiziertes Politikfeld (z.B. Gesundheit, Energie, Migration). Ein dominantes Thema pro Geschäft.',
  'filter.tooltip.aiIntent':            'KI-klassifizierte Absicht des Geschäfts (z.B. neues Gesetz vorschlagen, Bericht anfordern, Frage stellen).',
  'filter.tooltip.aiAudience':          'KI-klassifizierte Zielgruppe des Geschäfts (Bürger, Unternehmen, Kantone usw.).',
  'filter.tooltip.aiTrigger':           'KI-klassifizierter externer Auslöser des Geschäfts (Gerichtsentscheid, EU-Richtlinie, Vorfall in der Öffentlichkeit usw.).',
  'filter.tooltip.aiMinImpact':         'Mindest-Impact-Wert (1–10). Wie stark das Geschäft das Schweizer Recht oder die öffentliche Politik verändert. Bewertet durch KI.',
  'filter.tooltip.aiMinSensitivity':    'Mindest-Brisanzwert (1–10). Grad der politischen Kontroverse oder parteiübergreifenden Spannung. Bewertet durch KI.',
  'filter.tooltip.aiMinCentralization': 'Mindest-Zentralisierungswert (1–10). Wie stark das Geschäft Kompetenzen vom Kanton zum Bund verschiebt.',
  // Votes page (4.8 + IWP Bundle 1)
  'filter.tooltip.voteYear':            'Jahr der Abstimmung (Abstimmungsdatum), unabhängig vom Einreichungsjahr des zugrunde liegenden Geschäfts.',
  'filter.tooltip.voteStatus':          'Abstimmungsergebnis: angenommen, abgelehnt, Stichentscheid oder ausstehend.',
  'filter.tooltip.voteKeyword':         'Volltextsuche über Abstimmungstitel und zugrunde liegende Geschäftstitel.',
  'filter.tooltip.closeOnly':           'Nur knappe Abstimmungen anzeigen — Differenz von 10 Stimmen oder weniger zwischen Ja und Nein.',
  'filter.tooltip.splitOnly':           'Nur Abstimmungen anzeigen, in denen mindestens eine Fraktion intern um mehr als 20% gespalten war.',
  // Debates page (4.8 + IWP Bundle 1)
  'filter.tooltip.debateYear':          'Jahr, in dem die Debatte stattfand.',
  'filter.tooltip.language':            'Sprache der Rede (DE, FR, IT).',
  'filter.tooltip.speaker':             'Volltextfilter auf den Namen des Redners (Nachname genügt).',
  'filter.tooltip.role':                'Rolle des Redners in der Debatte: Berichterstatter, Bundesrat, ordentliches Mitglied usw.',
  'filter.tooltip.sentiment':           'Tonalität der Rede gemäss KI-Klassifikation: positiv, neutral oder negativ.',
  'filter.tooltip.position':            'Haltung gegenüber dem debattierten Geschäft: Dafür, Bedingte Zustimmung, Neutral oder Dagegen.',
  'filter.tooltip.federalism':          'Föderalismus-Ausrichtung der Rede: Bundesgewandt (Zentralisierung) oder kantonsgewandt (Dezentralisierung).',
  'filter.tooltip.amendment':           'Nur Reden anzeigen, in denen explizit ein Änderungsantrag gestellt wurde.',
  'filter.tooltip.businessFilter':      'Reden nach zugrunde liegender Geschäftsnummer filtern (z.B. 24.3145).',
  // Sessions page (4.8 + IWP Bundle 1)
  'filter.tooltip.sessionYear':         'Jahr, in dem die Session stattfand.',
  'filter.tooltip.season':              'Art der Session: ordentliche Frühlings-/Sommer-/Herbst-/Wintersession oder eine Sondersession.',
  // Committees page (4.8 + IWP Bundle 1)
  'filter.tooltip.committeeType':       'Art der Kommission: ständige Kommission, Aufsichtskommission oder andere Sonderorgane.',
  'filter.tooltip.committeeActive':     'Filtern, ob die Kommission derzeit aktiv ist oder aufgelöst/abgelöst wurde.',
  'filter.tooltip.commission':          'Nach einer übergeordneten ständigen Kommission (z. B. APK) und allen zugehörigen Gremien filtern — beide Räte, Subkommissionen und Arbeitsgruppen.',
  // Generic
  'filter.tooltip.search':              'Volltextsuche über Namensfelder. Nachname und Teiltreffer funktionieren beide.',
  // SessionPicker (IWP Bundle 2)
  'filter.allSessions':                 'Sessionen',
  'filter.tooltip.sessionPicker':       'Auf eine bestimmte Session filtern. Jahr wählen, dann aufklappen für Frühlings-, Sommer- oder Sondersession.',
  // SessionDetail — highly-relevant bills card (IWP Bundle 2)
  'session.highlights.title':           'Wichtigste Geschäfte dieser Session',
  'session.highlights.subtitle':        'Auf der Tagesordnung dieser Session stehende Geschäfte, von der KI nach Tragweite (Einfluss) und politischer Polarisierung als besonders bedeutsam eingestuft.',
  'session.highlights.empty':           'Keine Geschäfte mit hohen Einfluss- oder Polarisierungswerten auf der Tagesordnung dieser Session.',
  'empty.noResultsTitle': 'Keine Ergebnisse für diese Filter',
  'empty.noResultsHint':  'Entfernen Sie einen oder mehrere Filter, um die Suche zu erweitern.',
  'empty.removeFilter':   'Diesen Filter entfernen',
  'presets.save':              'Filter speichern',
  'presets.saveTooltip':       'Aktuelle Filter als Vorlage speichern',
  'presets.dropdown':          'Vorlagen',
  'presets.applyHeading':      'Vorlage anwenden',
  'presets.manageHint':        'Verwalten unter Einstellungen → Vorlagen',
  'presets.modal.title':       'Filter speichern',
  'presets.modal.nameLabel':   'Name',
  'presets.modal.namePlaceholder': 'z. B. SVP-Migrationsmotionen Q1 2025',
  'presets.modal.hint':        'Beim Speichern mit gleichem Namen wird die Vorlage überschrieben.',
  'presets.modal.cancel':      'Abbrechen',
  'presets.modal.save':        'Speichern',
  'presets.modal.saving':      'Speichert…',
  'common.results': 'Ergebnisse',
  'common.filteredBy': 'Gefiltert nach',

  // ── Benachrichtigungen / Beobachtungsliste ────────────────────────────
  'notif.bell.aria':                 'Benachrichtigungen',
  'notif.bell.unread':               'ungelesen',
  'notif.dropdown.title':            'Benachrichtigungen',
  'notif.dropdown.markAllRead':      'Alle als gelesen',
  'notif.dropdown.empty':            'Keine neuen Ereignisse.',
  'notif.dropdown.viewAll':          'Alle Benachrichtigungen anzeigen',
  'notif.row.voteResult':            'Schlussabstimmung zu {affair} — {title}',
  'notif.row.billStatus':            '{affair} — {title}: Status geändert zu {status}',
  'notif.row.sessionReminder':       'Sitzung beginnt bald: {name}',
  'notif.row.memberVote':            '{member} hat {decision} gestimmt zu {affair} — {title}',
  'notif.row.memberSpeech':          '{member} hat zu {affair} gesprochen — {title}',
  'notif.row.generic':               'Neues Ereignis zu einem beobachteten Geschäft',
  'notif.detail.voteTallies':        'Ja {yes} · Nein {no} · Enthaltung {abs}',
  'notif.detail.statusChange':       'Von "{from}" zu "{to}"',
  'notif.page.title':                'Benachrichtigungen',
  'notif.page.subtitle':             'Ereignisse zu den von Ihnen beobachteten Geschäften, Abstimmungen und Mitgliedern.',
  'notif.page.onlyUnread':           'Nur ungelesene',
  'notif.page.markAllRead':          'Alle als gelesen',
  'notif.page.empty':                'Noch keine Benachrichtigungen.',
  'notif.page.emptyUnread':          'Keine ungelesenen Benachrichtigungen.',
  'notif.page.emptyHint':            'Klicken Sie auf das Lesezeichen-Symbol bei einem Geschäft, um es zu beobachten.',
  'watch.watch':                     'Beobachten',
  'watch.watching':                  'Wird beobachtet',
  'watch.full':                      'Liste voll (max. 100)',
  'watch.error':                     'Aktualisierung fehlgeschlagen — bitte erneut versuchen',
  // Beobachtungslisten-Verwaltungsdialog (geöffnet via Einstellungen → Verwalten)
  'watchlist.modal.title.bills':     'Beobachtete Geschäfte',
  'watchlist.modal.title.members':   'Beobachtete Mitglieder',
  'watchlist.modal.title.votes':     'Beobachtete Abstimmungen',
  'watchlist.modal.empty.bills':     'Sie beobachten noch keine Geschäfte.',
  'watchlist.modal.empty.members':   'Sie beobachten noch keine Mitglieder.',
  'watchlist.modal.empty.votes':     'Sie beobachten noch keine Abstimmungen.',
  'watchlist.modal.emptyHint':       'Klicken Sie auf das Lesezeichen-Symbol auf einer Detailseite, um zu beobachten.',
  'watchlist.modal.unavailable':     'Nicht verfügbar',
  'watchlist.modal.open':            'Öffnen',
  'watchlist.modal.remove':          'Entfernen',
  'watchlist.modal.close':           'Schliessen',
  'watchlist.modal.done':            'Fertig',
  'watchlist.modal.filterBy':        'Filter',
  'watchlist.modal.clearFilter':     'Filter zurücksetzen',
  'watchlistTagFilter.label':        'Tags',
  'watchlistTagFilter.activeLabel':  '{n} Tag(s)',
  'watchlistTagFilter.dropdownTitle':'Ihre Beobachtungs-Tags',
  'watchlistTagFilter.clear':        'Zurücksetzen',
  'watchlistTagFilter.andHint':      'Elemente müssen alle ausgewählten Tags tragen.',
  'watchlistTagFilter.banner':       'Beobachtungsliste · {n} {kind}',
  'watchlistTagFilter.taggedLabel':  'getaggt',
  'watchlistTagFilter.emptyMatch':   'Keine beobachteten Elemente passen zu diesen Tags.',
  'watchlistTagFilter.emptyMatchHint':'Entfernen Sie einen Tag aus dem Filter oder fügen Sie weitere Elemente über das Beobachtungslisten-Modal hinzu.',
  'tags.selector.title':             'Tags',
  'tags.selector.noneYet':           'Noch keine Tags — erstellen Sie einen unter Einstellungen → Benachrichtigungen → Tags.',
  'tags.selector.createNew':         'Neuen Tag erstellen',
  'tags.selector.namePlaceholder':   'Tag-Name',
  'tags.selector.create':            'Erstellen',
  'tags.selector.cancel':            'Abbrechen',
  'tags.atCap':                      'max. 10',
  'tags.full':                       'Tag-Limit pro Element erreicht (max. 10)',
  'tags.duplicate':                  'Ein Tag mit diesem Namen existiert bereits',
  'tags.error':                      'Aktualisierung fehlgeschlagen — bitte erneut versuchen',
  'tagsManager.header':              'Ihre Tags',
  'tagsManager.empty':               'Noch keine Tags. Klicken Sie oben auf "Tag erstellen", um Ihre beobachteten Geschäfte und Mitglieder zu organisieren.',
  'tagsManager.hint':                'Beim Löschen eines Tags wird dieser auch von allen Elementen entfernt, an denen er angeheftet war.',
  'tagsManager.confirmDelete':       'Den Tag "{name}" löschen? Er wird von allen Elementen entfernt, an denen er angeheftet war.',
  'tagsManager.edit':                'Umbenennen / umfärben',
  'tagsManager.delete':              'Tag löschen',
  'tagsManager.save':                'Speichern',
  'tagsManager.cancel':              'Abbrechen',
  'tagsManager.create':              'Tag erstellen',
  'tagsManager.namePlaceholder':     'Tag-Name',
  'tagsManager.color':               'Farbe',
  'tagsManager.userCapReached':      'Tag-Limit erreicht (max. 30 pro Benutzer)',
  // Filter-chip Beschriftungen — siehe en.ts-Notiz: vorher fielen die Chips
  // auf den rohen Schlüssel-Text zurück, weil useT() den Schlüssel selbst
  // liefert, nicht das `|| 'Fallback'`-Suffix an der Aufrufstelle.
  'bills.affairNumber':       'Geschäftsnr.',
  'bills.type':               'Geschäftstyp',
  'bills.status':              'Status',
  'bills.department':         'Departement',
  'filter.language':          'Sprache',
  'filter.status':            'Status',
  'debates.role':             'Rolle',
  'chat.provenanceTooltip':   'Filter aus Chatbot-Vorschlag übernommen',
  'common.noResults': 'Keine Ergebnisse gefunden.',
  'common.clearFilters': 'Filter zurücksetzen',
  'common.current': 'Aktuell',
  'common.past': 'Früher',
  'common.present': 'Heute',
  'common.exportCSV': 'Als CSV exportieren',
  'csv.filtersApplied': 'Angewandte Filter',
  'csv.noFilters': 'Keine (alle Ergebnisse)',
  'csv.legislature': 'Legislatur',
  'csv.vote': 'Abstimmung',
  'csv.outcome': 'Ergebnis',
  // filters
  'filter.allParties': 'Parteien',
  'filter.allCantons': 'Kantone',
  'debates.partyTooltip':  'Reden nach Partei des Sprechers filtern. Gilt für die Trends-Ansicht; die Liste gruppiert nach Fraktion.',
  'debates.cantonTooltip': 'Reden nach Kanton des Sprechers filtern.',
  'filter.allFactions': 'Fraktionen',
  'filter.allCouncils': 'Räte',
  'filter.allGenders': 'Geschlechter',
  'filter.allYears': 'Jahre',
  'filter.allMembers': 'Mitglieder',
  'filter.allCommittees': 'Kommissionen',
  'filter.committee': 'Kommission',
  'filter.activeOnly': 'Aktiv',
  'filter.formerOnly': 'Ehemalige',
  'sort.by': 'Sortieren nach',
  'sort.name': 'Name',
  'sort.joined': 'Eintrittsjahr',
  'sort.cohesion': 'Kohäsion',
  'sort.dob':'Geburtsdatum',
  'sort.ascending': 'Aufsteigend',
  'sort.descending': 'Absteigend',
  'sort.submissionDate': 'Einreichungsdatum',
  'filter.canton': 'Kanton (z.B. ZH)',
  'filter.searchName': 'Nach Namen suchen…',
  // omni search
  'omni.placeholder':  'Mitglieder, Geschäfte, Abstimmungen, Reden suchen…',
  'omni.scopeLabel':   'Suche in',
  'omni.hint.members': 'Namen, Parteien, Kantone',
  'omni.hint.bills':   'Geschäfte nach Stichwort',
  'omni.hint.votes':   'Abstimmungstitel',
  'omni.hint.debates': 'Parlamentsreden',
  'omni.searching':    'Suche läuft…',
  'omni.noResults':    'Keine Ergebnisse für',
  'omni.viewAll':      'Alle anzeigen in',
  'omni.kbdNav':       'navigieren',
  'omni.kbdOpen':      'öffnen',
  'omni.kbdClose':     'schließen',
  'filter.party': 'Partei',
  'filter.faction': 'Fraktion',
  'filter.canton.label': 'Kanton',
  'filter.gender':  'Geschlecht',
  'filter.council': 'Rat',
  'filter.commission': 'Kommission',
  'filter.allCommissions': 'Kommissionen',
  'filter.tooltip.commissionAffair': 'Nach der zuständigen parlamentarischen Kommission filtern.',
  // councils
  'council.nr': 'Nationalrat',
  'council.sr': 'Ständerat',
  'council.bundesrat': 'Bundesrat',
  // gender
  'gender.male': 'Männlich',
  'gender.female': 'Weiblich',
  // members
  'members.title': 'Mitglieder / Räte',
  'members.legislativePeriod': 'Legislatur',
  'members.interest':          'Interesse',
  'members.interestMinCount':  'Interessen',
  'members.occupation':        'Beruf',
  'members.employer':          'Arbeitgeber',
  'members.nativeLanguage':    'Muttersprache',
  'members.subtitle': 'Aktive Parlamentsmitglieder durchsuchen.',
  // member detail tabs
  'tab.profile': 'Profil',
  'tab.activity': 'Aktivität',
  'tab.partyHistory': 'Parteigeschichte',
  'tab.history': 'Verlauf',
  'history.dim.party': 'Partei',
  'history.dim.council': 'Rat',
  'history.dim.legislation': 'Legislatur',
  'history.dim.commission': 'Kommission',
  'history.legislature': 'Legislatur',
  'member.noHistory': 'Kein Verlauf für diesen Filter.',
  'tab.votingRecord': 'Abstimmungsverhalten',
  'tab.speeches': 'Reden',
  'tab.bills': 'Eingereichte Geschäfte',
  // member detail sections
  'member.occupations': 'Berufe',
  'member.interests': 'Interessenbindungen',
  'member.noOccupations': 'Keine Berufsdaten verfügbar.',
  'member.born': 'Geboren',
  'member.gender': 'Geschlecht',
  'member.citizenship': 'Bürgerort',
  'member.nativeLang': 'Muttersprache',
  'member.marital': 'Zivilstand',
  'member.children': 'Kinder',
  'member.military': 'Militär',
  'member.elected': 'Gewählt',
  'member.oath': 'Vereidigung',
  'member.joined': 'Eingetreten',
  'member.left': 'Ausgetreten',
  'member.allMembers': 'Mitglieder',
  'member.totalVotes': 'Im Register',
  'member.totalVotesTip': 'Alle Abstimmungen im Register dieses Mitglieds, einschliesslich Abwesenheiten und entschuldigter Stimmen. Die Präsenzquote zeigt, an welchem Anteil dieser Abstimmungen das Mitglied tatsächlich teilgenommen hat.',
  'member.cast': 'Abgegeben',
  'member.castTip': 'Ja-, Nein- und Enthaltungsentscheidungen zusammen — die vom Mitglied persönlich abgegebenen Stimmen.',
  'member.yesRate': 'Ja-Anteil',
  'member.yesRateTip': 'Anteil aller Register-Abstimmungen, bei denen das Mitglied mit Ja gestimmt hat. Abwesenheiten zählen zum Nenner.',
  'member.noRate': 'Nein-Anteil',
  'member.noRateTip': 'Anteil aller Register-Abstimmungen, bei denen das Mitglied mit Nein gestimmt hat. Abwesenheiten zählen zum Nenner.',
  'member.abstainTip': 'Anteil aller Register-Abstimmungen, bei denen sich das Mitglied der Stimme enthalten hat. Abwesenheiten zählen zum Nenner.',
  'member.attendance': 'Präsenz',
  'member.attendanceTip': 'Anteil der Abstimmungen, an denen das Mitglied teilgenommen hat (Ja, Nein oder Enthaltung) – bezogen auf alle möglichen Abstimmungen während der Amtszeit.',
  'member.distribution': 'Abstimmungsverteilung',
  'member.paid': 'Bezahlt',
  'member.cohesion': 'Kohäsion',
  'member.cohesionTip': 'Wie oft stimmt dieses Mitglied bei Ja/Nein-Entscheidungen mit der Mehrheit seiner Fraktion.',
  'member.withFaction': 'Mit Fraktion',
  'member.withFactionTip': 'Ja/Nein-Abstimmungen, bei denen das Mitglied MIT der Mehrheit seiner Fraktion stimmte (Anzahl und Anteil = Kohäsion).',
  'member.againstFaction': 'Gegen Fraktion',
  'member.againstFactionTip': 'Ja/Nein-Abstimmungen, bei denen das Mitglied GEGEN die Mehrheit seiner Fraktion stimmte (Anzahl und Anteil).',
  'member.withMajority': 'Mit der Mehrheit',
  'member.withMajorityTip': 'Ja/Nein-Abstimmungen, bei denen das Mitglied auf der Gewinnerseite (Ratsmehrheit) stimmte — unabhängig von der Fraktion.',
  'member.withMinority': 'Mit der Minderheit',
  'member.withMinorityTip': 'Ja/Nein-Abstimmungen, bei denen das Mitglied auf der Verliererseite (Ratsminderheit) stimmte.',
  'member.votesLoadError': 'Abstimmungen konnten nicht geladen werden.',
  'member.cohesionOverTime': 'Fraktionstreue im Zeitverlauf',
  'member.cohesionChart.aligned': '{aligned} von {base} Fraktionsabstimmungen',
  'member.cohesionChart.dissent': '{n} gegen die Fraktion',
  'member.dissentOnly': 'Nur Abweichungen',
  'member.dissentBadge': 'Abweichung',
  'member.compare': 'Vergleichen',
  'member.compareBar': '{n} Mitglieder vergleichen',
  'member.compareHint': 'Bis zu 3 Mitglieder auswählen und vergleichen',
  'member.clearSelection': 'Auswahl löschen',
  'member.contact': 'Kontakt & Links',
  'member.topTopics': 'Top-Themen',
  'member.noPartyHistory': 'Keine Parteigeschichte vorhanden.',
  // debates
  'debates.title': 'Debatten & Reden',
  'debates.subtitle': 'Parlamentarische Reden mit semantischer KI-Suche durchsuchen.',
  'debates.searchPlaceholder': 'Reden semantisch oder nach Geschäftsnummer suchen (z. B. \'Klimapolitik\', 25.041)',
  'debates.speakerPlaceholder': 'Name des Redners',
  'debates.businessNumberPlaceholder': 'Geschäftsnummer (z. B. 25.218)',
  'debates.emptyTitle': 'Parlamentarische Reden suchen',
  'debates.emptySubtitle': 'Nutzen Sie die Suchleiste, um Reden per KI-Suche zu finden, oder filtern Sie nach Redner, Jahr oder Rat.',
  'debates.noResults': 'Keine Reden für diese Suchanfrage gefunden.',
  'debates.semanticMode': 'Semantische Suche',
  'debates.allLangs': 'Sprachen',
  'debates.recentSpeeches': 'Aktuelle Reden',
  'debates.debateSessions': 'Debattensitzungen',
  'debates.sessionUnknown': 'Session',
  'debates.loadingChronology': 'Vollständige Debattenchronologie wird geladen…',
  'debates.loadingMoreDebates': 'Weitere Debatten werden geladen…',
  'debates.backToDebates': 'Zurück zu Debatten',
  'debates.fullSpeech': 'Vollständige Rede',
  'debates.topSpeakers': 'Top-Redner',
  'debates.topSpeakersOnTopic': 'Meiste Reden zu diesem Thema',
  'debates.factionActivity': 'Fraktionsaktivität',
  'debates.contributionToTopic': 'Beitrag zum Thema',
  'debates.contributionOfTotal': '{count} von {total} Reden zum Thema',
  'debates.contributionRank': 'Rang {rank} von {total} Rednern zu diesem Thema',
  'debates.speeches': 'Reden',
  'debates.speakersCount': 'Redner',
  'debates.newestFirst': 'Neueste zuerst',
  'debates.oldestFirst': 'Älteste zuerst',
  'debates.debateThread': 'Debattenablauf',
  'debates.speechesInDebate': 'Reden in dieser Debatte',
  'debates.singleStatement': 'Einzelvotum',
  'debates.singleStatementTip': 'Nur eine Wortmeldung (meist ein Votum des Präsidiums oder der Berichterstattung) — kein Debattenverlauf.',
  'debates.viewSpeech': 'Vollständige Rede anzeigen',
  'debates.match': 'Übereinstimmung',
  'debates.date': 'Datum',
  'debates.council': 'Rat',
  'debates.affair': 'Geschäft',
  'debates.current': 'aktuell',
  'debates.unknownSpeaker': 'Unbekannte/r Redner/in',
  'debates.noTranscript': 'Kein Redetext für diese Rede verfügbar.',
  'debates.noTranscriptShort': 'Kein Redetext verfügbar.',
  'debates.viewOnParlament': 'Auf parlament.ch ansehen',
  'debates.parlamentCh': 'parlament.ch',
  'debates.searchCap': 'Suchindex-Limit',
  'debates.searchCapTip': 'Die Volltextsuche liefert maximal 1.000 Ergebnisse. Verwenden Sie Jahr-, Rats- oder Fraktionsfilter, um die Ergebnisse einzuschränken.',
  'debates.speechesPerMember': 'pro Mitglied',
  'debates.factionActivityNote': 'Balkenlänge normiert nach Fraktionsgröße',
  'debates.shareOfResults': 'Anteil an Ergebnissen',
  'debates.activeMembers': 'Aktive Mitglieder',
  'debates.filterByYear': 'Nach Jahr filtern',
  // AI enriched metadata
  'debates.moreFilters': 'Weitere Filter',
  'debates.aiInsights': 'KI-Einblicke',
  'debates.sentiment': 'Stimmung',
  'debates.position': 'Position',
  'debates.for': 'Dafür',
  'debates.against': 'Dagegen',
  'debates.positive': 'Positiv',
  'debates.negative': 'Negativ',
  'debates.amendments': 'Änderungsanträge',
  'debates.proposed': 'eingereicht',
  'debates.stanceSummary': 'Haltungszusammenfassung',
  'debates.federal': 'Bundesebene',
  'debates.cantonal': 'Kantonal',
  'debates.federalismStance': 'Föderalismus-Haltung',
  'debates.federalTip': 'Der Redner spricht sich dafür aus, dies auf Bundesebene (zentral) zu regeln, statt es den Kantonen zu überlassen.',
  'debates.cantonalTip': 'Der Redner spricht sich dafür aus, dies den Kantonen zu überlassen (dezentral), statt es auf Bundesebene zu regeln.',
  'debates.emotionality': 'Emotionalität',
  'debates.allRoles': 'Rollen',
  'debates.allSentiments': 'Stimmungen',
  'debates.allPositions': 'Positionen',
  'debates.allFederalism': 'Föderalismus',
  'debates.federalism': 'Föderalismus',
  // Sprecherrollen-Codes, die unten noch nicht abgedeckt sind (lib/debateEnums.ts).
  'debates.role.rapporteur': 'Berichterstatter',
  'debates.role.procedural': 'Verfahren',
  'debates.amendmentOnly': 'Änderungsantrag eingereicht',
  'debates.conditionalSupport': 'Bedingte Unterstützung',
  'debates.role.proponent': 'Befürworter',
  'debates.role.critic': 'Kritiker',
  'debates.role.expert': 'Experte',
  'debates.role.mediator': 'Vermittler/in',
  'debates.role.stateRep': 'Staatsvertreter',
  'common.neutral': 'Neutral',
  // bills
  'bills.title': 'Geschäfte',
  'bills.subtitle': 'Parlamentarische Geschäfte suchen und durchsuchen.',
  'bills.searchPlaceholder': 'Geschäfte nach Stichwort oder Nummer suchen…',
  'bills.semanticMode': 'Semantische Suche',
  'bills.browseMode': 'Strukturierte Suche',
  'bills.type.motion': 'Motion',
  'bills.type.postulate': 'Postulat',
  'bills.type.interpellation': 'Interpellation',
  'bills.type.parlInit': 'Parlamentarische Initiative',
  'bills.type.cantonInit': 'Standesinitiative',
  'bills.type.groupMotion': 'Fraktionsmotion',
  'bills.type.question': 'Anfrage',
  'bills.type.urgentQuestion': 'Dringliche Anfrage',
  'bills.type.simpleQuestion': 'Einfache Anfrage',
  'bills.type.federalBill': 'Bundesratsgeschäft',
  'bills.type.urgentInterp': 'Dringliche Interpellation',
  'bills.type.urgentSimple': 'Dringl. einfache Anfrage',
  'bills.type.recommendation': 'Empfehlung',
  'bills.type.petition': 'Petition',
  'bills.type.pag': 'Fraktionsanfrage',
  'bills.status.submitted': 'Eingereicht',
  'bills.status.referred': 'Überwiesen',
  'bills.status.inCommittee': 'In Kommission',
  'bills.status.planned': 'Geplant / Traktandiert',
  'bills.status.finalVote': 'Schlussabstimmung',
  'bills.status.concluded': 'Erledigt',
  'bills.status.reporting': 'Berichterstattung',
  'bills.status.statement': 'Stellungnahme vorhanden',
  'bills.tab.documents': 'Dokumente',
  'bills.tab.relatedBusiness': 'Verwandte Geschäfte',
  'bills.related.linked': 'Offizielle Verknüpfungen',
  'bills.related.semantic': 'Semantisch ähnlich',
  'bills.related.noSemantic': 'Keine ähnlichen Geschäfte gefunden.',
  'bills.related.votes': 'Verknüpfte Abstimmungen',
  'bills.tab.related': 'Verwandte & Abstimmungen',
  'bills.tab.fulltext': 'Volltext',
  'bills.tab.council': 'Bundesrat',
  'bills.cosignatories': 'Mitunterzeichnende',
  'bills.rapporteurs': 'Berichterstatter',
  'bills.preconsultations': 'Zuständige Kommissionen',
  'bills.legislativeDocs': 'Gesetzgebungsdokumente',
  'bills.noDocuments': 'Keine Gesetzgebungsdokumente vorhanden.',
  'bills.botschaft': 'Botschaft',
  // committees
  'committees.title': 'Kommissionen',
  'committees.subtitle': 'Parlamentarische Kommissionen und ihre Mitglieder',
  'committees.allCouncils': 'Räte',
  'committees.allCommissions': 'Kommissionen',
  'committees.national': 'Nationalrat',
  'committees.states': 'Ständerat',
  'committees.members': 'Mitglieder',
  'committees.function': 'Funktion',
  'committees.backToList': 'Zurück zu den Kommissionen',
  'committees.searchPlaceholder': 'Nach Name oder Mitglied suchen…',
  'committees.csv.abbreviation': 'Abkürzung',
  'committees.csv.name': 'Name',
  'committees.csv.council': 'Rat',
  'committees.csv.type': 'Typ',
  'committees.csv.members': 'Mitglieder',
  'committees.filterParty': 'Partei filtern',
  'committees.typeAll': 'Typen',
  'committees.statusAll': 'Status',
  'committees.statusActive': 'Aktiv',
  'committees.statusInactive': 'Inaktiv',
  'committees.typePermanent': 'Ständig',
  'committees.typeSpecial': 'Spezial',
  'committees.typeWorkgroup': 'Arbeitsgruppe',
  'bills.allTypes': 'Typen',
  'bills.allStatuses': 'Status',
  'bills.allDepartments': 'Departemente',
  'bills.exportCSV': 'Gefilterte Ergebnisse als CSV exportieren',
  'bills.moreFilters': 'Mehr Filter',
  'bills.numberFilter': 'Geschäftsnummer (z.B. 23.4488)',
  'bills.aiFilters': 'Weitere Filter',
  'bills.aiFilters.primaryTopic': 'Themen',
  'bills.aiFilters.subTopic': 'Unterthemen',
  'bills.aiFilters.intent': 'Absichten',
  'bills.aiFilters.audience': 'Zielgruppen',
  'bills.aiFilters.trigger': 'Auslöser',
  // AI-Enum-Wertübersetzungen (Backend speichert kanonisches Englisch; nur zur
  // Anzeige lokalisiert, kanonischer Wert wird an die API zurückgegeben).
  'affairs.intent.newLegislation':  'Neue Gesetzgebung',
  'affairs.intent.revision':        'Revision / Änderung',
  'affairs.intent.repeal':          'Aufhebung / Abschaffung',
  'affairs.intent.executive':       'Handlungsauftrag',
  'affairs.intent.reporting':       'Bericht / Untersuchung',
  'affairs.intent.intlAdaptation':  'Internationale Anpassung',
  'affairs.audience.citizens':         'Bürgerinnen und Bürger (allgemein)',
  'affairs.audience.smes':             'KMU / lokale Wirtschaft',
  'affairs.audience.largeEnterprises': 'Grossunternehmen',
  'affairs.audience.publicAdmin':      'Öffentliche Verwaltung',
  'affairs.audience.vulnerable':       'Sozial Benachteiligte',
  'affairs.audience.farmers':          'Landwirtschaft',
  'affairs.audience.healthcare':       'Gesundheitswesen',
  'affairs.audience.education':        'Bildung',
  'affairs.trigger.popularInitiative':  'Volksinitiative / Referendum',
  'affairs.trigger.intlMandates':       'Internationale Vorgaben (EU/OECD/UN)',
  'affairs.trigger.judicialRulings':    'Gerichtsentscheide',
  'affairs.trigger.techShift':          'Technologischer Wandel',
  'affairs.trigger.globalCrisis':       'Globale Krise',
  'affairs.trigger.internalInitiative': 'Interne Initiative',
  'bills.aiFilters.minImpact': 'Wirkung ≥',
  'bills.aiFilters.minSensitivity': 'Sensitivität ≥',
  'bills.aiFilters.minCentralization': 'Zentralisierung ≥',
  'bills.aiFilters.browseOnly': 'KI-Filter gelten nur im Browse-Modus',
  'bills.intelligence.title': 'KI-Analyse',
  'bills.quickStart.title': 'Erkunden — oder die Suche oben verwenden',
  'bills.quickStart.byYear': 'Nach Jahr',
  'bills.submittedBy': 'Eingereicht von…',
  'bills.timeline.submitted': 'Eingereicht',
  'bills.timeline.preconsultation': 'Vorberatung',
  'bills.timeline.parliamentaryVote': 'Parlamentarische Abstimmung',
  // votes
  'votes.title': 'Abstimmungen',
  'votes.subtitle': 'Parlamentarische Abstimmungsergebnisse durchsuchen.',
  'votes.councilScope.title': 'Nur Nationalrat',
  'votes.councilScope.tooltip': 'Diese Daten umfassen nur namentliche Abstimmungen des Nationalrats. Der Ständerat veröffentlicht seine Einzelstimmen ebenfalls, jedoch über eine separate Quelle, die in der von uns genutzten Abstimmungs-API des Parlaments nicht enthalten ist.',
  'votes.subtitleBusiness':  'Abstimmungen nach Geschäft gruppiert durchsuchen.',
  'votes.allCouncils': 'Räte',
  'votes.dataCoverageNote': 'Hinweis: Namentliche Abstimmungen des Ständerats sind ab 2022 verfügbar, jene des Nationalrats ab der Legislaturperiode 50 (2015). Ältere Legislaturperioden werden laufend ergänzt.',
  'votes.bothCouncils': 'Beide Räte haben über dieses Geschäft abgestimmt',
  'votes.oneCouncil': 'Nur der {council} hat über dieses Geschäft abgestimmt',
  'votes.chamberSwitchHint': 'Jeder Rat stimmt separat ab — wechseln, um die Mitglieder des anderen Rats zu sehen',
  'votes.subtitleHeatmap':   'Fraktion × Abstimmung-Matrix — Fraktionen erkennen, die sich spalten oder zusammenstehen.',
  'votes.subtitleAnalytics': 'Kohäsions-, Vergleichs-, Abweichungs- und Demografie-Analysen über das Abstimmungsregister.',
  'votes.analytics.keywordTooltip': 'Schränkt die zugrunde liegenden Abstimmungen nach Geschäftstitel oder Thema ein — z.B. "Klima" engt die Analyse auf klima-bezogene Abstimmungen ein.',
  'votes.analytics.businessNumberPlaceholder': 'Geschäftsnr. (z.B. 25.482)',
  'votes.analytics.businessNumberTooltip':     'Beschränkt die Analyse auf Abstimmungen zu diesem Geschäft.',
  'votes.analytics.scope.totalVotes':    'Abstimmungen',
  'votes.analytics.scope.finalVote':     'Schlussabst.',
  'votes.analytics.scope.finalTooltip':  'Gesamte Teilnahme über alle {events} Abstimmungsereignisse zum Geschäft {bnum}. Klicken, um die Schluss-/Hauptabstimmung zu öffnen.',
  'votes.tab.search': 'Suche',
  'votes.viewEvents': 'Abstimmungsereignisse',
  'votes.viewBusiness': 'Nach Geschäft',
  'votes.votingEvents': 'Abstimmungen',
  'votes.searchPlaceholder': 'Nach Titel, Gegenstand oder Geschäftsnummer suchen (z. B. 25.041)…',
  'votes.businessNumberPlaceholder': 'Geschäftsnummer (z.B. 25.3293)',
  'votes.passed': 'Angenommen',
  'votes.rejected': 'Abgelehnt',
  'votes.pending': 'Ausstehend',
  'votes.outcome.accepted': 'Vorlage angenommen',
  'votes.outcome.rejected': 'Vorlage abgelehnt',
  'votes.yes': 'Ja',
  'votes.no': 'Nein',
  'votes.abstain': 'Enthaltung',
  'votes.present': 'Anwesend',
  'votes.notPresent': 'Abwesend',
  'votes.excused': 'Entschuldigt',
  'votes.breakdown': 'Aufschlüsselung nach Fraktion',
  'votes.partyBreakdown': 'Aufschlüsselung nach Partei',
  'votes.individualVotes': 'Einzelabstimmungen',
  'votes.councillors': 'Ratsmitglieder',
  'votes.showAll': 'Alle anzeigen',
  'votes.againstFaction': 'Gegen Fraktion',
  'votes.seeDebates': 'Debatten anzeigen',
  'votes.surpriseFilter': 'Fraktionsteilung',
  'votes.tie': 'Stimmengleichheit',
  // Phase 2b — Übersetzungslabels für invertierte Abstimmungen
  // (Volksinitiativ-Schlussabstimmungen, prozedurale Schlüsselwort-Abstimmungen).
  'votes.invertedBadge': 'Invertierte Abstimmung',
  'votes.invertedTooltip.popularInitiative': 'Bei Schlussabstimmungen zu Volksinitiativen stimmt das Parlament über einen Bundesbeschluss zur Ablehnung ab — ein Ja bedeutet Annahme des Ablehnungsdekrets (= gegen die Initiative); ein Nein bedeutet Ablehnung des Dekrets (= für die Initiative).',
  'votes.invertedTooltip.keywordMatch': 'Die Frage ist so formuliert, dass ein Ja die negative Handlung bedeutet (Ablehnung / Nichteintreten / keine Folge) — Ja als Gegen die Vorlage lesen, Nein als Für die Vorlage.',
  'votes.invertedTooltip.generic': 'Ja und Nein in dieser Zeile lesen sich in die entgegengesetzte Richtung zur politischen Haltung zum zugrundeliegenden Geschäft.',
  'votes.forBill': 'Für',
  'votes.againstBill': 'Gegen',
  'votes.rawMechanicsTooltip': 'Rohe Ja/Nein-Zahlen — Abstimmungsmechanik, keine Haltung. Siehe die Für/Gegen-Zeile oben für die übersetzte Haltung zur Vorlage.',
  'votes.rawDecisionLabel': 'Rohe Stimme',
  'filter.allStances': 'Haltungen',
  'filter.tooltip.logicalStance': 'Nach übersetzter Haltung zur Vorlage filtern. Wird durch Chatbot-Navigation gesetzt; hier zurücksetzen oder ändern.',
  'votes.date': 'Datum',
  'votes.passRate': 'Annahmequote',
  'votes.contestedSub': '≤10 Stimmen Unterschied',
  'votes.perVote': 'Ratsmitglieder / Abstimmung',
  'votes.contested': 'Knappe Abstimmungen',
  'votes.avgParticipation': 'Ø Beteiligung',
  'votes.closestMargin': 'Knappste Mehrheit',
  'votes.closeVotesFilter': 'Knappe Abstimmungen',
  'votes.finalVoteFilter':  'Schlussabstimmungen',
  'votes.finalVoteTag':     'Schlussabstimmung',
  'votes.finalVoteTooltip': 'Schlussabstimmung zum Geschäft',
  'votes.meaning.yes':         'Ja',
  'votes.meaning.no':          'Nein',
  'votes.meaning.yesAccept':   'Ein Ja nimmt die Vorlage an.',
  'votes.meaning.noReject':    'Ein Nein lehnt die Vorlage ab.',
  'votes.meaning.yesReject':   'Ein Ja lehnt das Anliegen ab.',
  'votes.meaning.noAccept':    'Ein Nein nimmt das Anliegen an.',
  'votes.meaning.stichYes':    'Ja steht für den einen Vorschlag.',
  'votes.meaning.stichNo':     'Nein steht für den anderen Vorschlag.',
  'votes.meaning.yesGeneric':  'Ein Ja stimmt dem vorgelegten Antrag zu.',
  'votes.meaning.noGeneric':   'Ein Nein lehnt den vorgelegten Antrag ab.',
  'votes.meaning.invertedNote':'Achtung: Bei dieser Abstimmung ist die Ja/Nein-Bedeutung gegenüber dem Anliegen umgekehrt.',
  'votes.meaning.stichNote':   'Stichentscheid: Ja und Nein stehen je für einen konkurrierenden Vorschlag, nicht für Annahme oder Ablehnung.',
  'filter.tooltip.finalOnly': 'Nur Schlussabstimmungen anzeigen — Verfahrens- und Detailabstimmungen werden ausgeschlossen.',
  'votes.councillorFilter': 'Ratsmitglied',
  'votes.decisionFilter':   'Entscheid',
  'votes.meaningYesFilter': 'Ja bedeutet',
  'votes.speechAlignment':  'Redenhaltung',
  'votes.speechSentiment':  'Redenstimmung',
  'votes.viewHeatmap': 'Heatmap',
  'votes.viewAnalytics': 'Analytik',
  'votes.heatmapEmpty': 'Keine Heatmap-Daten verfügbar.',
  'votes.factionCol': 'Fraktion',
  // analytics tab
  'votes.analytics.modes.cohesion':     'Kohäsion',
  'votes.analytics.modes.comparison':   'Vergleich',
  'votes.analytics.modes.rebels':       'Abweichler',
  'votes.analytics.modes.demographics': 'Demografie',
  'votes.analytics.allYears':            'Jahre',
  'votes.analytics.since':               'Seit',
  'votes.analytics.yearFromTooltip':     'Nur Abstimmungen ab diesem Jahr',
  'votes.analytics.keywordPlaceholder':  'Nach Stichwort filtern…',
  'votes.analytics.cohesion.overallLabel':   'Ø Kohäsion',
  'votes.analytics.cohesion.overallTooltip': 'Durchschnittlicher Anteil der Fraktionsmitglieder, die mit der Mehrheit ihrer Fraktion stimmen, über alle ausgewählten Abstimmungen.',
  'votes.analytics.cohesion.acrossVotes':    'über {n} Abstimmungen',
  'votes.analytics.cohesion.unanimousLabel': 'Einstimmig',
  'votes.analytics.cohesion.unanimousSub':   '100% Kohäsion',
  'votes.analytics.cohesion.unanimousTooltip': 'Abstimmungen, bei denen die Fraktion vollständig geschlossen war — alle Mitglieder stimmten gleich (100% Kohäsion).',
  'votes.analytics.cohesion.splitLabel':     'Gespalten',
  'votes.analytics.cohesion.splitSub':       '<80% Kohäsion',
  'votes.analytics.cohesion.splitTooltip':   'Abstimmungen, bei denen die Fraktion gespalten war — weniger als 80% stimmten mit der eigenen Fraktionsmehrheit.',
  'votes.analytics.cohesion.totalVotesLabel':'Abstimmungen insg.',
  'votes.analytics.cohesion.totalVotesTooltip':'Anzahl der Abstimmungen, die nach den obigen Filtern in diese Auswertung einfliessen.',
  'votes.analytics.cohesion.trendTitle':     'Kohäsion im Zeitverlauf',
  'votes.analytics.cohesion.rankedTitle':    'Geschlossenste Abstimmungen',
  'votes.analytics.comparison.pickFactions': 'Fraktionen',
  'votes.analytics.comparison.overallTitle': 'Gesamtkohäsion nach Fraktion',
  'votes.analytics.comparison.trendTitle':   'Jährlicher Kohäsionstrend',
  'votes.analytics.comparison.factionCol':   'Fraktion',
  'votes.analytics.comparison.cohesionCol':  'Kohäsion',
  'votes.analytics.comparison.totalVotesCol':'Abstimmungen',
  'votes.analytics.comparison.unanimousCol': 'Einstimmig',
  'votes.analytics.comparison.splitCol':     'Gespalten',
  'votes.analytics.rebels.title':            'Häufigste Abweichler',
  'votes.analytics.rebels.allFactions':      'Fraktionen',
  'votes.analytics.rebels.minVotes':         'min. {n} Abstimmungen',
  'votes.analytics.rebels.defections':       'Abweichungen',
  'votes.analytics.rebels.tooltip':          'Eine Abweichung ist eine Stimme gegen die Mehrheit der eigenen Fraktion. Die Quote zeigt den Anteil der Stimmen eines Mitglieds, die von der Fraktion abwichen.',
  'votes.analytics.demographics.title':      'Abstimmungsverhalten nach Gruppe',
  'votes.analytics.demographics.bucketCol':  'Gruppe',
  'votes.analytics.demographics.yesShareCol':'Ja-Anteil',
  'votes.analytics.demographics.yesShareTooltip':'Anteil der abgegebenen Stimmen dieser Gruppe (Ja, Nein und Enthaltungen), die Ja waren.',
  'votes.analytics.demographics.yes':        'Ja',
  'votes.analytics.demographics.no':         'Nein',
  'votes.analytics.demographics.abstain':    'Enthaltung',
  'votes.analytics.demographics.total':      'Gesamt',
  'votes.analytics.demographics.groupBy.faction': 'Nach Fraktion',
  'votes.analytics.demographics.groupBy.party':   'Nach Partei',
  'votes.analytics.demographics.groupBy.canton':  'Nach Kanton',
  'votes.analytics.demographics.groupBy.gender':  'Nach Geschlecht',
  'votes.analytics.demographics.groupBy.council': 'Nach Rat',
  'votes.analytics.demographics.groupBy.tenure':  'Neulinge vs. Veteranen',
  // sessions
  'sessions.title': 'Sessionen',
  'sessions.subtitle': 'Parlamentssessionen durchsuchen, nach Jahr gruppiert.',
  'sessions.subtitleFiltered': '{count} Sessionen · {filters}',
  'sessions.live': 'Live',
  'sessions.lp': 'LP',
  'sessions.legislativePeriod': 'Legislatur',
  'sessions.passedTooltip': 'Anteil der sachentscheidenden Abstimmungen der Session, bei denen die Vorlage angenommen wurde. Gezählt werden nur Abstimmungen, die über eine Vorlage entscheiden – Ordnungs- und Stichentscheide sind ausgeschlossen, und Abstimmungen, bei denen ein «Ja» eine Vorlage ablehnt, werden nach ihrem tatsächlichen Ergebnis gewertet.',
  'sessions.passedTooltipBasis': 'Basierend auf {decided} sachentscheidenden von {total} durchgeführten Abstimmungen.',
  'sessions.meetings': 'Sitzungen',
  'sessions.agenda': 'Sitzungen & Traktanden',
  'sessions.votes': 'Abstimmungen',
  'sessions.agendaItems': 'Traktanden',
  'sessions.totalYes': 'Total Ja',
  'sessions.totalNo': 'Total Nein',
  'sessions.voteCount': 'Abstimmungen',
  'sessions.backToSessions': 'Zurück zu Sessionen',
  'sessions.noSubjects': 'Keine Traktanden vorhanden.',
  'sessions.noMeetings': 'Keine Sitzungsdaten vorhanden.',
  'sessions.totalVotesCast': 'Abstimmungen gesamt',
  'sessions.voteList': 'Abstimmungsliste',
  'sessions.spring': 'Frühling',
  'sessions.summer': 'Sommer',
  'sessions.autumn': 'Herbst',
  'sessions.winter': 'Winter',
  'sessions.special': 'Sondersession',
  'sessions.allSeasons': 'Sessionen',
  'sessions.yesNo': 'Ja / Nein',
  'sessions.liveBannerTitle': 'Das Parlament tagt gerade',
  'sessions.liveBannerEnds': 'Endet',
  'sessions.attendance': 'Anwesenheit',
  'sessions.attendanceTip': 'Ratsmitglieder nach Abwesenheitsquote in dieser Session. Nach Fraktion filtern, um die Liste einzuschränken.',
  'sessions.attendanceEmpty': 'Noch keine Einzelabstimmungsdaten für diese Session verfügbar.',
  'sessions.calendarGrid': 'Sessionskalender',
  'sessions.items': 'Traktanden',
  'session.discussion.topSpeakers': 'Aktivste Redner',
  'session.discussion.summary':     'Debattenübersicht',
  'session.discussion.speeches':    'Redebeiträge',
  'session.discussion.avgEmotion':  'Ø Emotionalität',
  'session.topics.policyAreas':     'Politikbereiche',
  'session.topics.keywords':        'Top-Themen dieser Session',
  // parties
  'parties.title': 'Parteien & Fraktionen',
  'parties.subtitle': 'Sitzverteilung, Geschlechterbalance und Kammerzugehörigkeit.',
  'parties.activeMembers': 'Aktive Mitglieder',
  'parties.nationalCouncil': 'Nationalrat',
  'parties.statesCouncil': 'Ständerat',
  // Faction code → recognisable party short-name (unity-ranking axis labels)
  'faction.party.V':   'SVP',
  'faction.party.S':   'SP',
  'faction.party.G':   'Grüne',
  'faction.party.GL':  'GLP',
  'faction.party.RL':  'FDP',
  'faction.party.M-E': 'Die Mitte',
  'faction.party.BD':  'BDP',
  'parties.femalePct': 'Frauenanteil',
  'parties.malePct': 'Männeranteil',
  'parties.seatDistribution': 'Sitzverteilung nach Fraktion',
  'parties.nrSrSplit': 'Kammerzugehörigkeit nach Fraktion',
  'parties.genderByFaction': 'Geschlecht nach Fraktion',
  'parties.femalePctByFaction': 'Frauenanteil nach Fraktion',
  'parties.factionDetails':      'Fraktionsdetails',
  'parties.ideologicalSpectrum': 'Ideologisches Spektrum (Links ↔ Rechts)',
  'parties.spectrum.expert': 'Expertenkonsens',
  'parties.spectrum.data': 'Abstimmungsdaten',
  'parties.spectrum.dataNote': 'aus paarweiser Fraktionsübereinstimmung in Parlamentsprotokollen berechnet',
  'parties.spectrum.dataTip': 'Position auf der Links-Rechts-Achse abgeleitet aus dem tatsächlichen Abstimmungsverhalten — wie ähnlich jede Fraktion im Vergleich zu SVP (rechts) und SP (links) abstimmt, normiert auf [−3, +3].',
  'parties.seats': 'Sitze',
  'parties.female': 'Frauen',
  'parties.parties': 'Parteien',
  'parties.viewMembers': 'Ansehen',
  'parties.cohesion':    'Kohäsion',
  'parties.cantonDistribution': 'Kantonsverteilung',
  'parties.dominantFaction': 'Stärkste Fraktion',
  // parties — tabs
  'parties.tab.assembly': 'Aktuelle Bundesversammlung',
  'parties.tab.assemblyTip': 'Die aktuelle Bundesversammlung — Nationalrat und Ständerat zusammen. Zeigt die dominierende Fraktion je Kanton und wo jedes Mitglied in beiden Räten sitzt.',
  'parties.tab.factions': 'Fraktionen',
  'parties.tab.factionsTip': 'Eine Fraktion kann Mitglieder aus mehreren Parteien vereinen. Z.B. sitzen EVP und Die Mitte gemeinsam in der Fraktion M-E.',
  'parties.tab.parties': 'Politische Parteien',
  'parties.tab.partiesTip': 'Politische Parteien als eingetragene Organisationen. Die Fraktion eines Mitglieds kann von seiner Partei abweichen, wenn mehrere Parteien eine Fraktion teilen.',
  // parties — map
  'parties.mapTooltipSeats': 'Sitze',
  'parties.factionFilterTip': 'Eine oder mehrere Fraktionen in beiden Räten hervorheben; die übrigen werden abgeblendet.',
  'parties.mapTooltipDominant': 'Stärkste',
  'parties.mapClickHint': 'Kanton anklicken, um dessen Mitglieder in den Sitzplänen unten hervorzuheben',
  // parties — faction card / drill-down
  'parties.viewFaction': 'Fraktionsprofil →',
  'parties.noFactions':  'Keine Fraktionsdaten verfügbar.',
  'parties.nonAligned':  'Fraktionslos / Parteilos',
  // parties — political parties tab
  'parties.party.active': 'aktiv',
  'parties.party.founded': 'Gegründet',
  'parties.party.dissolved': 'Aufgelöst',
  'parties.party.noParties': 'Keine Parteidaten verfügbar.',
  'parties.party.historical':     'Historisch',
  'parties.party.showHistorical': 'Historische Parteien anzeigen',
  'parties.party.hideHistorical': 'Historische Parteien ausblenden',
  // parties — KPI cards
  'parties.kpiSubtitle': 'Parlamentsweite Gesamtwerte aller Fraktionen',
  'parties.genderBalance': 'Geschlechterbalance',
  'parties.avgCohesion': 'Ø Kohäsion',
  'parties.acrossFactionsNote': 'über alle Fraktionen',
  // parties — chart card titles
  'parties.dominantFactionByCanton': 'Stärkste Fraktion pro Kanton',
  'parties.nrSeatsByFaction': 'Nationalrat — Sitzverteilung nach Fraktion',
  'parties.srSeatsByFaction': 'Ständerat — Sitzverteilung nach Fraktion',
  'parties.dominantPartyByCanton': 'Stärkste Partei pro Kanton',
  'parties.nrSeatsByParty': 'Nationalrat — Sitzverteilung nach Partei',
  'parties.srSeatsByParty': 'Ständerat — Sitzverteilung nach Partei',
  'parties.dominantFactionByCantonTip': 'Die stärkste Fraktion pro Kanton nach Sitzzahl. Auf einen Kanton klicken, um dessen Mitglieder in den Sitzplänen unten hervorzuheben.',
  'parties.hemicycleTip': 'Jeder Punkt ist ein Sitz, nach Fraktion von links nach rechts angeordnet. Über einen Punkt fahren oder eine Fraktion in der Legende anklicken, um sie hervorzuheben.',
  'parties.genderByFactionTip': 'Frauenanteil je Fraktion. Die gestrichelte Linie markiert den parlamentsweiten Durchschnitt.',
  'parties.nrSrSplitTip': 'Wie sich die Sitze jeder Fraktion auf Nationalrat und Ständerat verteilen. Mit „%-Ansicht" Anteile statt absoluter Sitze vergleichen.',
  'parties.seatingTip': 'Der echte Sitzungssaal — jedes Ratsmitglied auf seinem tatsächlichen Sitz, gemäss offiziellem Sitzplan des Parlaments. Für eine Übersicht über einen Sitz fahren; zum Öffnen des Profils anklicken.',
  'parties.seating.seat': 'Sitz',
  'parties.seating.noData': 'Noch keine Sitzdaten verfügbar',
  'parties.seating.canton': 'Kanton',
  'parties.seating.since': 'Im Parlament seit',
  'parties.seating.years': 'J.',
  'parties.seating.role': 'Funktion',
  'parties.seating.participation': 'Abstimmungsteilnahme',
  'parties.seating.cohesion': 'Geschlossenheit',
  'parties.seating.committees': 'Kommissionen',
  'parties.seating.profession': 'Beruf',
  'parties.seating.viewProfile': 'Profil öffnen',
  'parties.legislature': 'Legislatur',
  'parties.current': 'aktuell',
  'parties.seatingCurrentBadge': 'Aktuelle Kammer',
  'parties.pastLegVoteNote': 'Diagramme zum Abstimmungsverhalten (Geschlossenheit, Allianzen, ideologisches Spektrum) beruhen auf den erfassten namentlichen Abstimmungen der gewählten Legislatur, über beide Räte soweit verfügbar (Ständeratsabstimmungen werden erst ab 2022 erfasst).',
  'parties.currentChamberNote': 'Kammer-Momentaufnahme · aktuelle Legislatur',
  'parties.analyticsSection': 'Zusammensetzung & Abstimmungsanalyse',
  // parties — ideological spectrum
  'parties.naExcluded': 'Fraktionslose (NA) ausgeschlossen — unabhängige Mitglieder ohne klare ideologische Position.',
  'parties.allianceMatrix': 'Fraktions-Allianzmatrix',
  'parties.allianceMatrixTip': 'Anteil der Abstimmungen, bei denen beide Fraktionen gleich abgestimmt haben. 100% = immer gemeinsam, 0% = immer entgegengesetzt.',
  'parties.allianceMatrixNote': 'Basiert auf allen erfassten Abstimmungen.',
  'parties.cohesionTrend': 'Fraktionsgeschlossenheit im Zeitverlauf',
  'parties.partyUnityTrend': 'Parteigeschlossenheit im Zeitverlauf',
  'parties.cohesionTrendTip': 'Stimmgeschlossenheit der Fraktionen pro Parlamentssession.',
  'parties.spectrumClosest': 'Ideologisch am nächsten:',
  'parties.spectrumFurthest': 'Am weitesten entfernt:',
  'parties.spectrumPtsApart': 'Pkt. Abstand',
  'parties.spectrumGapNote': 'Experten↔Abstimmungs-Differenz',
  'parties.votesMoreRight': 'stimmt rechter als wahrgenommen',
  'parties.votesMoreLeft': 'stimmt linker als wahrgenommen',
  // parties — gender chart
  'parties.genderAvgLine': 'Parlamentsdurchschnitt',
  'parties.genderAvgTooltip': 'Parlamentsweiter Frauenanteil',
  // parties — faction table tooltips
  'parties.seatsShareTooltip': 'Anteil an allen Parlamentssitzen',
  'parties.naChambersNote': 'Mitglieder bekleiden Exekutivrollen (z.B. Bundesrat) und sind keiner Parlamentskammer zugeordnet',
  'parties.cohesionTooltip': 'Kohäsion misst, wie einheitlich eine Fraktion abstimmt. 100% bedeutet, alle Mitglieder stimmen immer gemeinsam ab. Niedrigere Werte zeigen interne Spaltungen. Farbe: grün ≥92%, amber 85–92%, rot <85%.',
  // parties — party table
  'parties.party.searchPlaceholder': 'Parteien suchen…',
  'parties.party.noCurrentMembers': 'Derzeit nicht im Parlament vertreten',
  'parties.party.nameColumn': 'Partei',
  'parties.party.abbrColumn': 'Kürzel',
  'parties.party.factionColumn': 'Fraktion',
  'parties.party.factionColumnTitle': 'Parlamentarische Fraktion dieser Partei',
  'parties.party.historicalSubtitle': 'Parteien mit einem erfassten Auflösungsdatum — inkl. Fusionen, Umbenennungen und aufgelöste Organisationen.',
  // parties — historical era labels
  'parties.party.era.pre1960': 'Vor 1960',
  'parties.party.era.196070': '1960er–70er',
  'parties.party.era.198090': '1980er–90er',
  'parties.party.era.2000s': '2000er–frühe 2010er',
  'parties.party.era.present': '2015 — heute',
  'parties.party.singular': 'Partei',
  'parties.party.plural': 'Parteien',
  // faction detail page
  'faction.backToParties': 'Zurück zu Parteien',
  'faction.overview': 'Übersicht',
  'faction.members': 'Mitglieder',
  'faction.interests': 'Lobbying & Interessen',
  'faction.statsNR': 'Nationalrat',
  'faction.statsSR': 'Ständerat',
  'faction.statsFemale': 'Frauen',
  'faction.statsMale': 'Männer',
  'faction.memberCount': 'Mitglieder',
  'faction.interestsByType': 'Interessen nach Typ',
  'faction.topOrganizations': 'Top-Organisationen',
  'faction.paid': 'Bezahlt',
  'faction.unpaid': 'Unbezahlt',
  'faction.noInterests': 'Keine Interessenbindungen für diese Fraktion verfügbar.',
  'faction.councillorsCount': 'Ratsmitglieder',
  'faction.cantonBreakdown': 'Mitglieder nach Kanton',
  'faction.recentVotes':     'Aktuelle Abstimmungen',
  'faction.factionVote':     'Fraktionsentscheid',
  // overview
  'overview.title': 'Parlumina',
  'overview.subtitle': 'Live-Daten aus der Bundesversammlung.',
  'overview.councillors': 'Räte',
  'overview.activeAffairs': 'Offene Geschäfte',
  'overview.votesThisYear': 'Abstimmungen dieses Jahr',
  'overview.currentSession': 'Aktuelle Session',
  'overview.activityTrends': 'Aktivitätstrends',
  'overview.votesBySession': 'Abstimmungen pro Session',
  'overview.partyComposition': 'Parteizusammensetzung',
  'overview.recentDebates': 'Aktuelle Debatten',
  'overview.passRate': 'Annahmequote (Jahr)',
  'overview.viewAll': 'Alle anzeigen',
  'overview.sessionLive': 'Live',
  'overview.sessionEnded': 'beendet vor',
  'overview.sessionUpcoming': 'beginnt in',
  'overview.speeches': 'Wortmeldungen',
  'overview.seats': 'Sitze',
  'overview.hotTopics': 'Zuletzt diskutiert',
  'overview.allLang': 'Alle',
  'overview.vsLastSession': 'vs. letzte Session',
  'overview.ofVotes': 'von {n} Abstimmungen',
  'overview.nrSrSplit': '{nr} NR · {sr} SR · +{br} BR · +{bk} BK',
  'overview.submittedThisYear': '{n} eingereicht dieses Jahr',
  'overview.allChambers': 'beide Räte',
  'overview.vsYear': 'vs. {year}',
  'overview.highImpactBills': 'Hochrelevante Geschäfte',
  'overview.viewDetails': 'Details',
  'overview.federalPush': 'Bundesdruck',
  'overview.balanced': 'Ausgewogen',
  'overview.cantonalLean': 'Kantonal geprägt',
  'overview.impactTooltipTitle': 'Politischer Impact',
  'overview.impactTooltipText': 'Wie stark dieses Geschäft das Schweizer Recht oder die öffentliche Politik verändert. Bewertet 1–10 durch KI.',
  'overview.sensitivityTooltipTitle': 'Politische Brisanz',
  'overview.sensitivityTooltipText': 'Grad der politischen Kontroverse oder parteiübergreifenden Spannung, die dieses Geschäft erzeugt. Bewertet 1–10 durch KI.',
  'overview.chart.clickToOpenSession': 'Klicken, um die Session zu öffnen',

  // Members table headers (4.8 — gap fixes)
  'member.council': 'Rat',
  'member.age':     'Alter',

  // Bills — type-tooltip descriptions (4.8 — gap fixes)
  'bills.type.tip.motion':            'Motion — verbindlicher Auftrag an den Bundesrat, eine Gesetzesvorlage einzubringen oder Massnahmen zu ergreifen.',
  'bills.type.tip.postulate':         'Postulat — unverbindliche Empfehlung an den Bundesrat, ein Thema zu prüfen.',
  'bills.type.tip.interpellation':    'Interpellation — schriftliche Anfragen an den Bundesrat, die eine formelle schriftliche Antwort erfordern.',
  'bills.type.tip.parlInitiative':    'Parlamentarische Initiative — ein Mitglied legt direkt einen Gesetzesentwurf vor, ohne den Bundesrat einzubeziehen.',
  'bills.type.tip.cantonInitiative':  'Standesinitiative — ein Kanton schlägt eine Änderung der Bundesverfassung oder eines Bundesgesetzes vor.',
  'bills.type.tip.groupMotion':       'Fraktionsmotion — eine von einer ganzen parlamentarischen Fraktion gemeinsam eingereichte Motion.',
  'bills.type.tip.simpleQuestion':    'Einfache Anfrage — eine kurze schriftliche Anfrage an den Bundesrat.',
  'bills.type.tip.federalCouncilBill':'Bundesratsvorlage — ein Gesetzesentwurf, der direkt von der Exekutive eingebracht wird.',
  'bills.type.tip.urgentInterp':      'Dringliche Interpellation — eine Interpellation, die eine dringliche Antwort erfordert.',
  'bills.type.tip.urgentSimple':      'Dringliche einfache Anfrage — eine dringliche kurze schriftliche Anfrage an den Bundesrat.',
  'bills.type.tip.urgentQuestion':    'Dringliche Anfrage — erfordert eine sofortige Antwort des Bundesrats.',
  'bills.type.tip.recommendation':    'Empfehlung — eine unverbindliche Empfehlung an eine Kommission oder Behörde.',
  'bills.type.tip.petition':          'Petition — ein von Bürgerinnen und Bürgern an das Parlament gerichtetes Anliegen.',
  'bills.type.tip.parlGroupMotion':   'Fraktionsantrag — ein von einer parlamentarischen Fraktion eingereichter Antrag.',

  // Usage page (admin / developer-only cost dashboard)
  'usage.title':                  'Nutzung',
  'usage.subtitle':               'Token-Verbrauch und geschätzte Kosten über alle Chat-Clients.',
  'usage.errorLoad':              'Nutzungsdaten konnten nicht geladen werden',
  'usage.range.7d':               'Letzte 7 Tage',
  'usage.range.30d':              'Letzte 30 Tage',
  'usage.range.90d':              'Letzte 90 Tage',
  'usage.range.365d':             'Letztes Jahr',
  'usage.kpi.messages':           'Nachrichten',
  'usage.kpi.messagesHint':       'Eine pro gestellter Frage',
  'usage.kpi.apiCalls':           'API-Aufrufe',
  'usage.kpi.apiCallsHint':       'Anthropic-Antworten (inkl. Tool-Iterationen)',
  'usage.kpi.estimatedCost':      'Geschätzte Kosten',
  'usage.kpi.costPer100':         '{cost} pro 100 Nachrichten',
  'usage.kpi.totalTokens':        'Gesamttokens',
  'usage.kpi.titleGenCost':       'Titel-Generierung',
  'usage.kpi.cacheHitRate':       'Cache-Trefferquote',
  'usage.kpi.cacheHitRateHint':   '{saved} gespart · {eff} des cacheable Prefix getroffen',
  'usage.col.hitRate':            'Trefferquote',
  'usage.kpi.titleGenHint':       'Groq Llama 3.1 8B',
  'usage.kpi.users':              'Benutzer',
  'usage.legend.input':           'Eingabe',
  'usage.legend.output':          'Ausgabe',
  'usage.legend.cacheRead':       'Cache gelesen',
  'usage.legend.cacheCreate':     'Cache geschrieben',
  'usage.perModelTitle':          'Pro Modell (Chat-Agent)',
  'usage.col.model':              'Modell',
  'usage.col.msgs':               'Nachr.',
  'usage.col.input':              'Eingabe',
  'usage.col.output':             'Ausgabe',
  'usage.col.cacheRead':          'Cache gelesen',
  'usage.col.cacheCreate':        'Cache geschrieben',
  'usage.col.estCost':            'Gesch. Kosten',
  'usage.unknownModel':           'unbekannt',
  'usage.titleGenTitle':          'Titel-Generierung',
  'usage.titleGenNote':           '(Groq, separater Anbieter)',
  'usage.titleGen.col.sessionsTitled':    'Benannte Sitzungen',
  'usage.titleGen.col.promptTokens':      'Prompt-Tokens',
  'usage.titleGen.col.completionTokens':  'Completion-Tokens',
  'usage.pillLabelTitle':                 'Filter-Pill-Beschriftungen',
  'usage.pillLabelNote':                  '(Groq, pro Turn — UI-Feinschliff)',
  'usage.pillLabel.col.turnsLabelled':    'Beschriftete Turns',
  'usage.perUserTitle':           'Pro Benutzer',
  'usage.perUserCount':           '({count} insgesamt)',
  'usage.showMore':               '{count} weitere anzeigen',
  'usage.collapse':               'Einklappen',
  'usage.user.col.user':          'Benutzer',
  'usage.user.col.sessions':      'Sitzungen',
  'usage.user.col.messages':      'Nachrichten',
  'usage.user.col.apiCalls':      'API-Aufrufe',
  'usage.user.col.cacheRW':       'Cache L/S',
  'usage.user.col.costPer100':    '$ / 100 Nachrichten',
  'usage.user.col.lastActivity':  'Letzte Aktivität',
  'usage.user.nameUnknown':       'Name unbekannt',
  'usage.footnote':               'Nachricht = ein Gesprächs-Austausch: die Frage des Nutzers + alle internen Tool-Iterationen + die finale Antwort der KI, zusammen als eins gezählt. API-Aufrufe ist die rohe Anzahl der Anthropic-Antworten (≥ Nachrichten, da der Agent pro Iteration einen API-Aufruf absetzt). Kosten & Tokens sind über alle Aufrufe summiert. $ / 100 Nachrichten ist die Budget-Hochrechnung — was würden bei den aktuellen Kosten pro Nachricht 100 Nachrichten kosten? Nur Schätzungen — die tatsächliche Anbieterrechnung kann abweichen. Titel-Generierung: Groq Llama 3.1 8B Instant ($0.05 / $0.08 pro Mio.). Chat-Agent: Anthropic Claude Haiku 4.5 ($1 Eingabe / $5 Ausgabe pro Mio., Cache-Reads $0.10, 5-Min.-Cache-Writes $1.25).',

  // ── Einstellungen-Seite ────────────────────────────────────────────────────
  'settings.title':                  'Einstellungen',
  'settings.subtitle':               'Verwalten Sie Ihre Einstellungen, Benachrichtigungen und Systemdaten.',
  'settings.manageAccount':          'Konto verwalten',
  'settings.tab.preferences':        'Einstellungen',
  'settings.tab.notifications':      'Benachrichtigungen',
  'settings.tab.managePresets':      'Filter verwalten',
  'settings.tab.system':             'System',
  'settings.appearance':             'Darstellung',
  'settings.theme':                  'Design',
  'settings.theme.desc':             'Farbschema des Dashboards.',
  'settings.theme.light':            'Hell',
  'settings.theme.dark':             'Dunkel',
  'settings.theme.system':           'System',
  'settings.language':               'Sprache',
  'settings.language.desc':          'Sprache für Datenbeschriftungen und Oberfläche.',
  'settings.navigation':             'Navigation',
  'settings.landingPage':            'Startseite',
  'settings.landingPage.desc':       'Nach dem Login angezeigte Seite.',
  'settings.aiChat':                 'KI-Chat',
  'settings.showWidget':             'Chat-Widget anzeigen',
  'settings.showWidget.desc':        'InnoChat-Assistenten auf allen Seiten anzeigen.',
  'settings.about':                  'Über',
  'settings.appVersion':             'App-Version',
  'settings.appVersion.desc':        'Parlumina',
  'settings.dataSource':             'Datenquelle',
  'settings.dataSource.desc':        'Offene Daten der Schweizer Bundesversammlung.',
  'settings.dataUpdated':            'Daten aktualisiert',
  'settings.dataUpdated.desc':       'Neuester aus dem Parlamentsregister synchronisierter Eintrag.',
  'settings.dataUpdated.unknown':    'Unbekannt',
  'settings.aiAssistant':            'KI-Assistent',
  'settings.aiAssistant.desc':       'Unterstützt von INNOCHAT — der KI-Plattform von InnoQ.',
  'settings.alertPrefs':             'Benachrichtigungseinstellungen',
  'settings.alert.votes':            'Abstimmungsergebnisse',
  'settings.alert.votes.desc':       'Benachrichtigen, wenn ein verfolgtes Geschäft in die Schlussabstimmung geht.',
  'settings.alert.bills':            'Geschäftsstatus-Änderungen',
  'settings.alert.bills.desc':       'Warnen, wenn ein beobachtetes Geschäft fortschreitet oder abgeschlossen wird.',
  'settings.alert.browser':          'Browser-Benachrichtigungen',
  'settings.alert.browser.blocked':  'Vom Browser blockiert — in den Seiten-Einstellungen ändern.',
  'settings.alert.browser.desc':     'Push-Benachrichtigungen in diesem Browser aktivieren.',
  'settings.watchlist':              'Beobachtungsliste',
  'settings.watchlist.members':      'Beobachtete Ratsmitglieder',
  'settings.watchlist.bills':        'Beobachtete Geschäfte',
  'settings.watchlist.empty':        'Noch nichts gespeichert.',
  'settings.watchlist.countOne':     '1 Element gespeichert.',
  'settings.watchlist.countMany':    '{n} Elemente gespeichert.',
  'settings.watchlist.manage':       'Verwalten',
  'settings.tags':                   'Tags',
  'settings.presets.signIn':         'Melden Sie sich an, um Ihre gespeicherten Filter zu verwalten.',
  'settings.presets.title':          'Gespeicherte Filter',
  'settings.presets.empty':          'Noch keine gespeicherten Filter. Setzen Sie unter Mitglieder, Geschäfte, Debatten oder Abstimmungen die gewünschten Filter und klicken Sie auf „Filter speichern", um sie hier zu behalten.',
  'settings.presets.deleteTooltip':  'Filter löschen',
  'settings.presets.delete':         'Löschen',
  'settings.presets.updated':        'Aktualisiert am {date}',
  'settings.presets.countOne':       '1 Filter',
  'settings.presets.countMany':      '{n} Filter',
  'settings.presets.loadError':      'Filter konnten nicht geladen werden',
  'settings.presets.deleteError':    'Löschen fehlgeschlagen',
  'settings.developer':              'Entwickler',
  'settings.chatProvider':           'Chatbot-Modellanbieter',
  'settings.chatProvider.label':     'Aktiver Anbieter',
  'settings.chatProvider.desc':      'Entwicklersteuerung. Legt fest, welches LLM den Chatbot für ALLE Nutzer beantwortet — nicht nur für Sie. Wirkt ab der nächsten Antwort.',
  'settings.chatProvider.anthropic': 'Anthropic (Claude Sonnet)',
  'settings.chatProvider.openai':    'OpenAI (GPT-5.4 mini)',
  'settings.chatProvider.loadError': 'Aktueller Anbieter konnte nicht geladen werden.',
  'settings.chatProvider.saveError': 'Anbieter konnte nicht gewechselt werden. Bitte erneut versuchen.',
  'settings.devInspector':           'Entwickler-Inspector',
  'settings.devInspector.desc':      'Zeigt unter jeder KI-Antwort die Tool-Aufrufe, Argumente und Ergebnis-Vorschauen des Agenten. Deaktivieren, um den Chat genau wie ein normaler Nutzer zu sehen.',
  // citations + speech/vote correlation
  'debates.conditional': 'Bed.',
  'citation.type.councillor': 'Profil',
  'citation.type.affair': 'Geschäft',
  'citation.type.dispatch': 'Botschaft',
  'citation.type.speech': 'Votum',
  'citation.source': 'Quelle',
  'citation.aria': 'Quelle {id}: {label}',
  // chat widget
  'chat.entity.member': 'Mitglied',
  'chat.entity.session': 'Session',
  'chat.entity.bill': 'Vorlage',
  'chat.entity.vote': 'Abstimmung',
  'chat.entity.debate': 'Debatte',
  'chat.entity.faction': 'Fraktion',
  'chat.context.dashboard': 'Parlaments-Dashboard',
  'chat.viewing': 'Ansicht:',
  'chat.context.syncActive': 'Der Assistent weiss, was Sie ansehen – die aktuelle Seite sowie gesetzte Filter und geöffnete Elemente.',
  'chat.context.syncInactive': 'Kein Seitenkontext zum Teilen – der Assistent beantwortet allgemeine Fragen. Öffnen Sie eine Datenseite, um zum Angezeigten zu fragen.',
  'chat.toast.newSession': 'Neue Unterhaltung gestartet',
  'chat.fab.aria': 'Parlaments-KI-Chat öffnen',
  'chat.collapse': 'Einklappen',
  'chat.expand': 'Ausklappen',
  'chat.newSession': 'Neue Unterhaltung',
  'chat.mode.speed': 'Schnell',
  'chat.mode.quality': 'Qualität',
  'chat.mode.speedTip': 'Schnelle Antworten — niedrige Latenz, gute Qualität',
  'chat.mode.qualityTip': 'Beste Qualität — tiefere Antworten, höhere Latenz',
  'chat.dashboardFiltered': 'Dashboard gefiltert:',
  'chat.clearFilter': 'Filter löschen',
  'chat.input.placeholder': 'Fragen Sie zum Parlament…',
  'chat.input.signingIn': 'Anmeldung…',
  'chat.send': 'Nachricht senden',
  'chat.stop': 'Generierung stoppen',
  'chat.stopped': 'Gestoppt.',
  // multi-select control + canton map tooltip
  'multiselect.selected': '{n} ausgewählt',
  'multiselect.noOptions': 'Keine Optionen',
  'cantonMap.dominantParty': 'Stärkste Partei',
  'cantonMap.faction': 'Fraktion',
  'cantonMap.dominantFaction': 'Stärkste Fraktion',
  'cantonMap.party': 'Partei',
  // member activity chart
  'common.pp': 'Pp.',
  'member.activity.voteParticipation': 'Abstimmungsbeteiligung',
  'member.activity.participation': 'Beteiligung',
  'member.activity.votesOfTotal': '{n} von {total} Abstimmungen',
  // localization pass: bill detail / parties / session detail
  'billDetail.typeTip.motion': 'Motion — verbindlicher Auftrag an den Bundesrat, eine Gesetzesvorlage einzubringen oder zu handeln.',
  'billDetail.typeTip.postulate': 'Postulat — unverbindliche Empfehlung, mit der der Bundesrat beauftragt wird, einen Sachverhalt zu prüfen.',
  'billDetail.typeTip.interpellation': 'Interpellation — schriftliche Fragen an den Bundesrat, die eine förmliche schriftliche Antwort erfordern.',
  'billDetail.typeTip.parliamentaryInit': 'Parlamentarische Initiative — ein Ratsmitglied bringt eine Vorlage direkt ein, ohne den Bundesrat einzubeziehen.',
  'billDetail.typeTip.cantonalInit': 'Standesinitiative — ein Kanton schlägt eine Änderung der Bundesverfassung oder der Bundesgesetzgebung vor.',
  'billDetail.typeTip.groupMotion': 'Fraktionsmotion — eine gemeinsam von einer ganzen Fraktion eingereichte Motion.',
  'billDetail.typeTip.simpleQuestion': 'Einfache Anfrage — eine kurze schriftliche Frage an den Bundesrat.',
  'billDetail.typeTip.federalCouncilBill': 'Bundesratsvorlage — eine direkt von der Exekutive eingebrachte Vorlage.',
  'billDetail.typeTip.urgentInterpellation': 'Dringliche Interpellation — eine Interpellation, die eine dringliche Antwort erfordert.',
  'billDetail.typeTip.urgentSimpleQuestion': 'Dringliche einfache Anfrage — eine dringliche kurze schriftliche Frage an den Bundesrat.',
  'billDetail.typeTip.urgentQuestion': 'Dringliche Anfrage — erfordert eine sofortige Antwort des Bundesrates.',
  'billDetail.typeTip.recommendation': 'Empfehlung — eine unverbindliche Empfehlung an eine Kommission oder Behörde.',
  'billDetail.typeTip.petition': 'Petition — ein von Bürgerinnen und Bürgern beim Parlament eingereichtes Anliegen.',
  'billDetail.typeTip.parliamentaryGroupMotion': 'Fraktionsmotion — eine von einer Fraktion eingereichte Motion.',
  'billDetail.pipeline.submitted': 'Eingereicht',
  'billDetail.pipeline.review': 'In Beratung',
  'billDetail.pipeline.vote': 'Schlussabstimmung',
  'billDetail.pipeline.concluded': 'Erledigt',
  'billDetail.tab.debates': 'Reden',
  'billDetail.tab.activity': 'Aktivitätsverlauf',
  'billDetail.tab.votes': 'Abstimmungen',
  'billDetail.tab.similar': 'Ähnliche Geschäfte',
  'billDetail.furtherDocs': 'Weiterführende Unterlagen',
  'billDetail.officialBulletin': 'Amtliches Bulletin',
  'billDetail.notFound': 'Geschäft nicht gefunden.',
  'billDetail.lp.title': 'Legislaturperiode',
  'billDetail.meta.status': 'Stand der Beratungen',
  'billDetail.meta.legislativePeriod': 'Legislaturperiode',
  'billDetail.meta.commission': 'Kommission',
  'billDetail.meta.category': 'Behandlungskategorie',
  'billDetail.category.I': 'Freie Debatte',
  'billDetail.category.II': 'Organisierte Debatte',
  'billDetail.category.III': 'Fraktionsdebatte',
  'billDetail.category.IV': 'Kurzdebatte',
  'billDetail.category.V': 'Verkürztes Verfahren',
  'billDetail.lp.tooltip': 'Die vierjährige Amtsdauer der Bundesversammlung, während der die gewählten Mitglieder im Amt sind.',
  'billDetail.triggerTip.popularInitiative': 'Volksinitiative — Bürgerinnen und Bürger können mit 100’000 gültigen Unterschriften innert 18 Monaten eine Änderung der Bundesverfassung vorschlagen. Referendum — ein vom Parlament verabschiedetes Gesetz kann einer Volksabstimmung unterstellt werden, wenn innert 100 Tagen 50’000 Unterschriften gesammelt werden.',
  'billDetail.triggerTip.intlMandates': 'Ausgelöst durch Verpflichtungen internationaler Gremien (EU, OECD, UNO), die die Schweiz in nationales Recht umsetzen muss.',
  'billDetail.triggerTip.judicialRulings': 'Veranlasst durch einen Gerichtsentscheid (z. B. des Bundesgerichts oder des EGMR), der eine Anpassung der Gesetzgebung erfordert.',
  'billDetail.triggerTip.techShift': 'Eine Reaktion auf neue Technologien oder digitale Entwicklungen, die das geltende Recht noch nicht abdeckt.',
  'billDetail.triggerTip.globalCrisis': 'Ausgelöst durch eine internationale Krise (Pandemie, Krieg, Finanzschock), die eine gesetzgeberische Antwort verlangt.',
  'billDetail.triggerTip.internalInitiative': 'Entsteht innerhalb des Parlaments oder der Bundesverwaltung und nicht aus einem externen Ereignis.',
  'billDetail.triggerTip.generic': 'Das externe Ereignis oder der Prozess, der dieses Geschäft ausgelöst hat.',
  'billDetail.tags.label': 'Themen',
  'billDetail.debates.councilFilter': 'Rat',
  'billDetail.debates.showingRange': '{from}–{to} von {total} Wortmeldungen',
  'billDetail.debates.pageOf': 'Seite {page} von {pages}',
  'billDetail.meta.submitted': 'Eingereicht',
  'billDetail.meta.statusDate': 'Statusdatum',
  'billDetail.description': 'Beschreibung',
  'billDetail.noShortDescription': 'Für dieses Geschäft ist keine Kurzbeschreibung verfügbar.',
  'billDetail.viewFullText': 'Volltext anzeigen',
  'billDetail.submittedTo': 'Eingereicht bei: ',
  'billDetail.activityTimeline': 'Aktivitätsverlauf',
  'billDetail.fullText.initialSituation': 'Ausgangslage',
  'billDetail.fullText.submittedText': 'Eingereichter Text',
  'billDetail.fullText.reason': 'Begründung',
  'billDetail.fullText.motion': 'Antrag',
  'billDetail.noFullText': 'Kein Volltext verfügbar.',
  'billDetail.proposalCode': 'Antragscode',
  'billDetail.council.response': 'Stellungnahme des Bundesrates',
  'billDetail.council.proposalText': 'Antragstext',
  'billDetail.council.proposal': 'Antrag des Bundesrates',
  'billDetail.council.proposalCodeTip': 'Der Code, den die offiziellen Parlamentsdaten für den Antrag des Bundesrates verwenden (z. B. 44 = Annahme, 45 = Ablehnung, 46 = teilweise Annahme). Die Beschriftung zeigt die Bedeutung.',
  'billDetail.council.proceedings': 'Verhandlungen',
  'billDetail.council.noResponse': 'Keine Stellungnahme des Bundesrates verfügbar.',
  'billDetail.debates.loadError': 'Debatten konnten nicht geladen werden. Der Suchindex ist möglicherweise vorübergehend nicht verfügbar.',
  'billDetail.debates.empty': 'Für dieses Geschäft wurden keine Parlamentsvoten gefunden.',
  'billDetail.debates.emptyChamber': 'Keine Wortmeldungen aus diesem Rat zu diesem Geschäft.',
  'billDetail.votes.emptyChamber': 'Keine Abstimmungen aus diesem Rat zu diesem Geschäft.',
  'billDetail.debates.stateRep': 'Standesvertr.',
  'billDetail.debates.amendmentProposed': 'Änderungsantrag eingereicht',
  'billDetail.debates.amendment': 'Änderungsantrag',
  'billDetail.debates.emotionality': 'Emotionalität',
  'parties.noData': 'Keine Daten',
  'parties.totalSuffix': 'insgesamt',
  'parties.nrSeats': 'NR-Sitze',
  'parties.srSeats': 'SR-Sitze',
  'parties.csv.abbreviation': 'Abkürzung',
  'parties.csv.name': 'Name',
  'parties.csv.total': 'Total',
  'parties.csv.nr': 'NR',
  'parties.csv.sr': 'SR',
  'parties.csv.female': 'Frauen',
  'parties.csv.male': 'Männer',
  'parties.csv.cohesion': 'Kohäsion (%)',
  'parties.csv.activeMembers': 'Aktive Mitglieder',
  'parties.csv.founded': 'Gegründet',
  'parties.avg': 'Ø',
  'parties.spectrum.left': 'Links',
  'parties.spectrum.right': 'Rechts',
  'parties.selfAlways100': 'Sich selbst — immer 100%',
  'parties.agreement': 'Übereinstimmung',
  'parties.recordedVotesCount': '{a} von {b} erfassten Abstimmungen',
  'parties.recordedVotes': 'erfasste Abstimmungen',
  'parties.cohesionAxis': 'Geschlossenheit (%)',
  'parties.threshold90': '90%-Schwelle',
  'parties.chamber.nr': 'Nationalrat',
  'parties.chamber.sr': 'Ständerat',
  'parties.cohesionNoChamberData': 'Keine Ständerat-Kohäsionsdaten für diesen Zeitraum – namentliche Abstimmungen liegen erst ab 2022 vor.',
  'parties.filteredBy': 'Gefiltert nach:',
  'parties.filtered': 'Gefiltert:',
  'parties.nonAlignedFootnote': '{count} Fraktionslose nicht dargestellt — Mitglieder üben Exekutivämter (Bundesrat) aus, die keiner parlamentarischen Kammer zugeordnet sind.',
  'parties.pctView': '%-Ansicht',
  'parties.sort': 'Sortieren:',
  'parties.sortLeftRight': 'Links → Rechts',
  'parties.sortAlphabetical': 'Alphabetisch',
  'parties.self': 'Sich selbst',
  'parties.seatsProportionTitle': 'Anteil an allen Parlamentssitzen',
  'parties.nrShort': 'NR',
  'parties.srShort': 'SR',
  'parties.notAffiliatedTitle': 'Mitglieder ohne Zugehörigkeit zu einer registrierten Partei',
  'sessionDetail.councilVbv': 'VBV',
  'sessionDetail.councilVbvFull': 'Vereinigte Bundesversammlung',
  'sessionDetail.noSrVotes': 'Für diese Session sind keine namentlichen Abstimmungen des Ständerats erfasst (verfügbar ab 2022).',
  'sessionDetail.donutTooltip': 'Summe aller einzelnen Ja-/Nein-/Enthaltungs-Stimmen über sämtliche namentlichen Abstimmungen dieser Session — Gesamtzahl der Stimmen, nicht der Abstimmungen.',
  'sessionDetail.kpiAcceptedTooltip': 'Wie viele der sachentscheidenden Abstimmungen mit Annahme der Vorlage endeten (und deren Anteil). Ordnungs- und Stichentscheide sind ausgeschlossen; Abstimmungen, bei denen ein «Ja» eine Vorlage ablehnt, werden nach ihrem tatsächlichen Ergebnis gewertet.',
  'sessionDetail.kpiRejectedTooltip': 'Wie viele sachentscheidende Abstimmungen mit Ablehnung der Vorlage endeten (und deren Anteil). Gleiche Grundlage wie der Annahme-Wert — ohne Ordnungs- und Stichentscheide.',
  'sessionDetail.kpiParticipationTooltip': 'Durchschnittliche Zahl der Ratsmitglieder, die pro Abstimmung Ja, Nein oder Enthaltung stimmen — also die Anwesenden. Abwesenheiten und Entschuldigungen zählen nicht.',
  'sessionDetail.calendarCountHint': 'Die Zahl neben jedem Rat (z. B. NR · 11) gibt die Anzahl der an diesem Tag behandelten Traktanden an.',
  'sessionDetail.noSession': 'Keine Sitzung',
  'sessionDetail.passRate': 'Annahmequote',
  'sessionDetail.searchAgenda': '{n} Traktanden durchsuchen…',
  'sessionDetail.avgParticipation': 'Durchschnittliche Beteiligung',
  'sessionDetail.councillorsPerVote': 'Ratsmitglieder / Abstimmung',
  'sessionDetail.votesPerDay': 'Abstimmungen pro Tag',
  'sessionDetail.mostContested': 'Am umstrittensten',
  'sessionDetail.margin': 'Differenz',
  'sessionDetail.colAffair': 'Geschäft',
  'sessionDetail.colTitle': 'Titel',
  'sessionDetail.colResult': 'Ergebnis',
  'sessionDetail.viewVoteBreakdown': 'Abstimmungsdetails anzeigen',
  'sessionDetail.absent': 'abwesend',
  'sessionDetail.votes': 'Abstimmungen',
  'sessionDetail.totalAgendaItems': 'Traktanden insgesamt',
  'common.weekday.mon': 'Mo',
  'common.weekday.tue': 'Di',
  'common.weekday.wed': 'Mi',
  'common.weekday.thu': 'Do',
  'common.weekday.fri': 'Fr',
  'common.weekday.sat': 'Sa',
  // localization pass 2: votes / members / bills / sessions / debates
  'votes.stichfrage': 'Stichfrage',
  'votes.yesShort': 'Ja',
  'votes.noShort': 'Nein',
  'votes.factionSplit': 'Fraktion gespalten',
  'votes.noData': 'keine Daten',
  'votes.voteNumber': 'Abstimmung Nr. ',
  'voteDetail.sortYesPct': 'Ja %',
  'voteDetail.sortNoPct': 'Nein %',
  'voteDetail.sortAbstain': 'E',
  'voteDetail.sortTotal': '#',
  'voteDetail.sortName': 'A–Z',
  'voteDetail.sortLabel': 'Sortieren',
  'voteDetail.filterLabel': 'Filter',
  'voteDetail.sortYesPctTip': 'Nach dem Ja-Stimmenanteil je Fraktion sortieren (höchster zuerst)',
  'voteDetail.sortNoPctTip': 'Nach dem Nein-Stimmenanteil je Fraktion sortieren (höchster zuerst)',
  'voteDetail.sortAbstainTip': 'Nach Enthaltungen (E) sortieren – anwesend, aber weder Ja noch Nein gestimmt',
  'voteDetail.sortTotalTip': 'Nach der Gesamtzahl der Mitglieder je Fraktion sortieren',
  'voteDetail.sortNameTip': 'Alphabetisch nach Name sortieren',
  'voteDetail.filterAllTip': 'Alle Fraktionen anzeigen',
  'voteDetail.filterYesTip': 'Nur Fraktionen mit Ja-Mehrheit',
  'voteDetail.filterNoTip': 'Nur Fraktionen mit Nein-Mehrheit',
  'voteDetail.filterSplitTip': 'Nur Fraktionen mit Stimmengleichheit – gleich viele Ja- und Nein-Stimmen',
  'voteDetail.csvFirstName': 'Vorname',
  'voteDetail.csvLastName': 'Nachname',
  'voteDetail.csvCanton': 'Kanton',
  'voteDetail.csvFaction': 'Fraktion',
  'voteDetail.csvDecision': 'Entscheid',
  'voteDetail.csvDecisionCode': 'Entscheidcode',
  'voteDetail.abstainShort': 'E',
  'voteDetail.absentShort': 'abw.',
  'voteAnalytics.cohesionSuffix': 'Geschlossenheit',
  'faction.notFound': 'Fraktion nicht gefunden.',
  'faction.partyComposition': 'Parteizusammensetzung',
  'faction.memberSearchPlaceholder': 'Nach Name, Kanton, Partei filtern…',
  'faction.canton': 'Kanton',
  'faction.subjectCol': 'Gegenstand',
  'faction.organizationCol': 'Organisation',
  'faction.compensationCol': 'Vergütung',
  'faction.interestsClickHint': 'Auf einen Balken oder ein Label klicken, um die Organisationen unten zu filtern.',
  'faction.typeCol': 'Typ',
  'faction.totalSuffix': 'total',
  'members.csv.name': 'Name',
  'members.csv.party': 'Partei',
  'members.csv.faction': 'Fraktion',
  'members.csv.canton': 'Kanton',
  'members.csv.council': 'Rat',
  'members.csv.active': 'Aktiv',
  'members.appliedByChatbot': 'Vom Chatbot angewendet',
  'bills.csv.number': 'Nummer',
  'bills.csv.title': 'Titel',
  'bills.csv.type': 'Typ',
  'bills.csv.status': 'Status',
  'bills.csv.submissionDate': 'Einreichungsdatum',
  'bills.scoreDots.impactDescription': 'Wie breit dieses Geschäft die Gesellschaft, die Wirtschaft oder die öffentliche Politik betrifft.',
  'bills.scoreDots.sensitivityDescription': 'Wie politisch umstritten oder spaltend dieses Geschäft voraussichtlich ist.',
  'common.other': 'Andere',
  'memberDetail.speechCount': '{count} Voten',
  'memberCompare.remove': 'Entfernen',
  'sessions.csv.session': 'Session',
  'sessions.csv.abbreviation': 'Kürzel',
  'sessions.csv.type': 'Typ',
  'sessions.csv.startDate': 'Beginn',
  'sessions.csv.endDate': 'Ende',
  'sessions.csv.legislativePeriod': 'Legislaturperiode',
  'sessions.csv.votes': 'Abstimmungen',
  'sessions.csv.passRate': 'Annahmequote (%)',
  'sessions.passRateComparison': 'Vergleich der Annahmequote',
  'sessions.comparisonTitle': 'Sessionsvergleich',
  'sessions.vsLastSession': 'ggü. letzter Session',
  'sessions.vsSameSeasonLastYear': 'ggü. gleicher Session im Vorjahr',
  'sessions.passRateSuffix': '% angenommen',
  'debates.csv.date': 'Datum',
  'debates.csv.speaker': 'Redner/in',
  'debates.csv.faction': 'Fraktion',
  'debates.csv.canton': 'Kanton',
  'debates.csv.council': 'Rat',
  'debates.csv.businessNumber': 'Geschäftsnummer',
  'debates.csv.businessTitle': 'Geschäftstitel',
  'debateDetail.missingSpeechId': 'Fehlende Redebeitrags-ID. Navigieren Sie über eine Debattenkarte hierher.',
  'debateDetail.role.proponent': 'Befürworter/in',
  'debateDetail.role.critic': 'Gegner/in',
  'debateDetail.role.expert': 'Expertin/Experte',
  'debateDetail.role.mediator': 'Vermittler/in',
  'debateDetail.role.stateRep': 'Bundesrat',
  'debateDetail.role.proponentDesc': 'Spricht für die behandelte Vorlage — verteidigt oder befürwortet deren Annahme.',
  'debateDetail.role.criticDesc': 'Spricht kritisch gegen die Vorlage — bringt Einwände oder Widerstand vor. Beschreibt den rhetorischen Ton des Votums, nicht zwingend das tatsächliche Abstimmungsverhalten.',
  'debateDetail.role.expertDesc': 'Spricht aus fachlicher Sicht — erläutert oder klärt, ohne Partei zu ergreifen.',
  'debateDetail.role.mediatorDesc': 'Sucht den Kompromiss oder vermittelt zwischen den gegnerischen Positionen.',
  'debateDetail.role.stateRepDesc': 'Spricht im Namen der Regierung / des Bundesrats (z. B. ein Bundesrat), nicht als Fraktionsmitglied.',
  'debateDetail.role.rapporteur': 'Berichterstatter/in',
  'debateDetail.role.rapporteurDesc': 'Offizielle Kommissionssprecherin bzw. -sprecher — vertritt die formelle Position der Kommission im Plenum, nicht eine persönliche Haltung.',
  'debateDetail.role.procedural': 'Verfahren',
  'debateDetail.role.proceduralDesc': 'Äussert sich zum Verfahren (Ordnungsanträge, Traktandierung, Abstimmungsmodus) statt zum Inhalt der Vorlage.',
  'debateDetail.role.aiNote': 'KI-klassifiziert aus dem Redetext. Kann vom tatsächlichen Abstimmungsverhalten abweichen.',
  'debateDetail.sentiment.positive': 'Positiv',
  'debateDetail.sentiment.neutral': 'Neutral',
  'debateDetail.sentiment.negative': 'Negativ',
  'debateDetail.sentiment.positiveDesc': 'Der emotionale Grundton der Rede ist positiv — zustimmend, optimistisch oder unterstützend formuliert.',
  'debateDetail.sentiment.neutralDesc': 'Der emotionale Grundton der Rede ist neutral — sachlich oder ausgewogen, ohne starke positive oder negative Färbung.',
  'debateDetail.sentiment.negativeDesc': 'Der emotionale Grundton der Rede ist negativ — kritisch, ablehnend oder pessimistisch formuliert. Beschreibt den Ton, nicht zwingend die Haltung des Mitglieds.',
  'debateDetail.emotionality.tooltip': 'Wie emotional aufgeladen die Sprache der Rede ist, auf einer Skala von 0 bis 10. Höhere Werte bedeuten eine kraftvollere, leidenschaftlichere Wortwahl; niedrigere Werte einen sachlichen, nüchternen Ton.',
  'debateDetail.alignment.forDesc': 'Das Votum unterstützt die behandelte Vorlage — spricht sich für deren Annahme aus.',
  'debateDetail.alignment.againstDesc': 'Das Votum lehnt die behandelte Vorlage ab — spricht sich gegen deren Annahme aus.',
  'debateDetail.alignment.neutralDesc': 'Das Votum bezieht keine klare Position für oder gegen die Vorlage.',
  'debateDetail.alignment.conditionalDesc': 'Das Votum unterstützt die Vorlage nur unter bestimmten Bedingungen oder Änderungen.',
  'committee.memberHeading': 'Mitglied',
  // localization pass 3: notifications / layout / cards / misc components
  'notif.unread': 'ungelesen',
  'notif.ago.seconds': 'vor {n} Sek.',
  'notif.ago.minutes': 'vor {n} Min.',
  'notif.ago.hours': 'vor {n} Std.',
  'notif.ago.days': 'vor {n} Tagen',
  'doc.permalink': 'Permalink',
  'doc.breadcrumb': 'Navigationspfad',
  'doc.copy': 'Kopieren',
  'doc.copyCode': 'Code kopieren',
  'layout.expandSidebar': 'Seitenleiste ausklappen',
  'layout.collapseSidebar': 'Seitenleiste einklappen',
  'topbar.signIn': 'Anmelden',
  'tags.removeTag': 'Tag entfernen',
  'tags.defaultColor': 'Standard',
  'card.untitledAffair': '(Geschäft ohne Titel)',
  'card.councillor': 'Ratsmitglied',
  'card.unknownCouncillor': 'Unbekannt',
  'statusBadge.unknown': 'Unbekannt',
  'filterPreset.saveFailed': 'Speichern fehlgeschlagen',
  'devInspector.toolCall': '{count} Tool-Aufruf',
  'devInspector.toolCalls': '{count} Tool-Aufrufe',
  'devInspector.iter': '{count} Iter.',
  'devInspector.iterationLine': 'Iter. {iteration} · Modell {modelMs}ms · Tools {toolMs}ms',
  'devInspector.argsCount': '{count} Argumente',
  'devInspector.args': 'Argumente',
  'devInspector.resultPreview': 'Ergebnisvorschau',
  'chat.thinking': 'Denkt nach',
};

export default de;
